import Locale from 'element-ui/lib/locale/lang/en.js' // 引入element语言包
const en = {
  login: {
    name: '',
    page: '',
    lanuage: 'Language',
    text: 'Login with email',
    text2: 'Login with code',
    email: 'Email',
    placeholdername: 'Email',
    placeholderemail: 'Please fill in your e-mail address',
    emailformate: 'Wrong e-mail format',
    placeholderpsw: 'Password',
    login: 'Login',
    account: 'Remember me',
    password: 'Remember password',
    rememberPhone: 'Remember phone',
    getCode: 'Send',
    register: 'Register',
    passwords: 'Forgot password?',
    pswr: 'Please fill in your password',
    emailr: 'Verification code',
    phone: 'Login with phone',
    phoneplace: 'Mobile phone number',
    phoneerror: 'Wrong mobile phone number format',
    phoneverify: 'Verification code',
    countryTitle: 'Country/Region',
    tokenError: 'Login timeout!',
    accountDisabled: 'Account disabled!',
    userNotActivated: 'Account is not activated!',
    userFrozen: 'Account has been frozen!',
    tryAgain: ' try again later',
    validPhoneNumber: 'Please enter a valid phone number.',
    simplifiedChinese: 'Simplified Chinese'
  },
  sync: {
    overflow: 'overflow',
    manle: `The scenes in this device are full and cannot participate in scene 【 $$】. To join a new scene, please delete existing scenes first, then click [Retry].`,
    data: 'Start time',
    areaname: 'Area',
    time: 'Time',
    identification: 'Identify',
    retry: 'Retry',
    delete: 'Delete',
    synchronizing: 'Synchronising',
    cousreTitle: 'Data sychronising',
    background: 'Run in background',
    allTry: 'Retry all',
    info: 'Info',
    alltry: 'Retry all',
    close: 'Close',
    area: 'Area',
    scene: 'Scene',
    ifttt: 'Automation',
    config: 'Configure',
    projectId: 'Project ID',
    constIllumination: 'Daylight control',
    rhythm: 'Schedule'
  },
  sylogs: {
    dataControlTip: 'Only three months of data are presented',
    dataControlTip1: 'Only display the most recent 50 entries. Switch dates to view data for a specific day',
    infor: 'Info',
    warning: 'Warning',
    error: 'Error',
    to: 'To',
    startdate: 'Start time',
    enddate: 'End time',
    plhode2: 'Level',
    plhode3: 'Name',
    plhode4: 'EventID',
    plhode5: 'Details',
    search: 'Search',
    out: 'Export',
    dates: 'Date',
    lever: 'Level',
    id: 'Cloud ID',
    name: 'Name',
    EventID: 'EventID',
    detail: 'Detail',
    waring: 'Device address conflict',
    all: 'All',
    downfiletip: 'File exporting, please wait...',
    systemModuleName: 'Relevent Function',
    userActionTypeName: 'Action Type',
    urlPath: 'Path',
    arguments: 'Arguments',
    callResultCode: 'Result',
    uCloudId: 'Cloud ID',
    ipAddress: 'IP',
    success: 'Succeed',
    fail: 'Failed',
    datapickerLimit: 'The maximum export duration is 1 month, please readjust your settings',
    allEvent: 'All events'
  },
  failureLogs: {
    dates: 'Report time',
    id: 'Cloud device ID',
    name: 'Device name',
    area: 'Area',
    failure: 'Fault condition',
    operation: 'Operation',
    failureRemind: 'Fault alarm',
    time: 'Time',
    go: 'Check details '
  },
  otaUpdate: {
    customTime: 'Custom Schedule',
    notStarting: 'Manual execution',
    name: 'Device',
    type: 'Type',
    online: 'Online',
    Update: 'Upgrade',
    caozuo: 'Task',
    update: 'Upgrade',
    know: 'Identify',
    stop: 'Stop',
    tab1: 'All',
    tab2: 'Upgrade needed',
    tab3: 'Upgrading',
    tab4: 'Success',
    tab5: 'Fail',
    offline: 'Offline',
    identification: 'Identify',
    upgrade: 'Upgrade',
    initiatefail: 'Fail',
    ingfail: 'Fail',
    success: 'Success',
    warninginfor: 'None',
    waitForupgrade: 'Waiting for upgrade',
    Upgradeing: 'Upgrading',
    UpgradeSuccess: 'Upgrade successful',
    UpgradeDuplicate: 'Duplicated',
    UpgradeFail: 'Failed',
    UpgradeConfilct: 'Conflict occured!',
    UpgradeBusy: 'Busy',
    UpgradeProjectIdNull: 'No project ID',
    info: 'Info',
    stopfail: 'Fail',
    stopsuccess: 'Success',
    wakeUpDeviceAndUpgrade: 'Please wake up the device by following the steps below, then click "Upgrade Now" to complete the update',
    webMeshOtaNotSupported: 'The current Bluetooth firmware version does not support Web Mesh OTA. Please use App GATT upgrade',
    upgradeNow: 'Upgrade Now',
    automaticUpgrade: 'Automatic Upgrade'
  },
  addThirdDevice: {
    addgateway: 'Add a Smart Connect Box',
    span: 'Add a 3rd party device',
    step1: 'Select Smart Connect Box',
    step2: 'Select Protocol',
    step3: 'Device Type',
    save: 'Save',
    back: 'Back',
    productKey: 'All strings of the QR code'
  },
  addVirtualGateway: {
    next: 'Next',
    previous: 'Back',
    devicename: 'Device',
    writedevicename: 'Device name',
    span: 'Add Smart Connect Box',
    step1: '1.Select type',
    step2: '2.Input info',
    header: 'Select type',
    typewarning: 'Select type',
    success: 'Success',
    error: 'Fail',
    confiminfor: 'Device was in another project,are you sure to continue?',
    notice: 'Notice',
    sure: 'Sure',
    back: 'Back',
    cancle: 'Cancel'
  },
  forgetpsw: {
    account: 'Email',
    password: 'Password',
    surepassword: 'Confirm your password',
    emailr: 'Please fill in your verification code',
    yanzhneg: 'Code',
    placeholderemail: 'Please fill in your e-mail address',
    placeholderpsw: 'Please fill in your password',
    placeholderpswagain: 'Please fill in your password again',
    name: 'Smart lighting project',
    setnewpsw: 'Set password',
    setpsw: 'Find password',
    agree: 'Read and accept the User Privacy Policy',
    ok: 'Finish',
    moredpsw: 'Please fill in your password',
    passnosame: 'The password does not match',
    pswr2: 'Please use 6-15 numbers and letters',
    emailformate: 'Wrong e-mail format',
    userLive: 'User Live',
    userOff: 'User Off'
  },
  findGateway: {
    next: 'Next',
    previous: 'Back',
    devicename: 'Device',
    suredevice: 'Confirm',
    countdown: 'Count',
    '120s': 'Please click the "Confirm" button on the Smart Connect Box as shown in the picture above, and then click "Next".',
    g2Confirm: 'Please click the "Mesh" button on the Smart Connect Box as shown in the picture above, and then click "Next".',
    mac: 'MAC address',
    macplaceholder: 'Please fill in the MAC address',
    scanning: 'Scan the QR code',
    infor1: 'Connect it to the internet',
    infor2: 'Please fill in the MAC address',
    span: 'Add Smart Connect Box',
    step1: '1. Select Smart Connect Box type',
    step2: '2. Follow the instructions and reset the Smart Connect Box',
    step3: '3. Assign your Smart Connect Box',
    step4: '4. Confirm',
    step5: '5. Find Smart Connect Box',
    step6: 'You can still press the button of the connect box to pair it to the network if you just forgot it.',
    header: 'Select Smart Connect Box type',
    typewarning: 'Select Smart Connect Box type',
    macwarning: 'Please fill in the MAC address',
    success: 'Search Success',
    error: 'Search Fail',
    confiminfor: 'This Smart Connect Box already exists in the current project. Do you want to continue?',
    notice: 'Notice',
    sure: 'Continue',
    back: 'Back',
    cancle: 'Cancel',
    macerror: 'Wrong format.Please check your MAC address again',
    textHeader: 'Restore factory settings and networking',
    textOne: 'Reset the Smart Connect Box by pressing the reset button on the side.',
    textTwo: 'Reset the Smart Connect Box by pressing the reset button on the side.',
    textThree: 'The green ON/OFF icon will start flashing.',
    textfour: 'Press and hold until all 3 icons on top have flashed once. This indicates a successful reset.',
    textfive: 'Static IP,',
    textsix: 'Then proceed by: Returning to this page after completing the configuration via static IP setup.',
    textseven: ' The connect box needs unblocked internet access (firewall can limit this), make sure all 3 LED indicators are on. Please always ',
    texteight: 'WIFI,',
    texteight1: 'Contact local IT',
    textnine: ' to inform if you need to whitelist the Connect Box.',
    textnine1: 'If static IP is required then please proceed to set',
    textnine2: 'Static IP.',
    staticipsetcaption: 'Static IP setting method',
    staticipsetcaption1: 'The local IT needs to know:',
    staticipsetinfo: '“Static IP” in blue will refer to the SOP, same as how it works rightnow in this step./nContact your IT manager upfront and get the static IP information (IP address, Subnet mask and Default gateway) intended for the Smart Connect Box./nEnable the Bootloader Mode of the Smart Connect Box to open the communication<br>- Connect the Smart Connect Box direct to your computer via the Ethernet cable;  <br>- Open the Start menu ➔ PC Setting ➔ Network & Internet ➔ Ethernet ➔ Change adapter options ➔ Choose the relevant Ethernet port ➔ Double click to enter the Ethernet Property page ➔ Double click on Internet Protocol Version 4 (TCP/IPv4) ➔ General ➔ Use the following IP address <br>- Configure the IP of your computer to 192.168.1. X (X could be 2 ~ 254), subnet mask to 255.255.255.0;  Default Gateway IP must be 192.168.1.1 , press OK to save the changes. <br>- Press and hold the function key of the Smart Connect Box (the square button) for 15 seconds until the green power LED-indicator flashes. This indicates the Smart Connect Box is activated with the bootloader program. <br>/nOpen your web browser and enter 192.168.1.1 to enter the Smart Connect Box web page;/nIn the Ethernet Configuration ➔ Change IP setting from DHCP to Static IP ➔ Fill in the required IP address, subnet mask, gateway (from the IT manager) ➔ Click Save to save the changes ;/nPress the function key again to restart the Smart Connect Box. The Smart Connect box will now use the static IP address which was set.',
    staticipsetinfo5: `“Static IP” in blue will refer to the SOP, same as how it works right now in this step./n
Contact your IT manager upfront and get the static IP information (IP address, Subnet mask and Default Gateway) intended for the Smart Connect Box G2./n
Connect the router’s LAN port directly to the Smart Connect Box using an Ethernet cable./n
Access your router’s administration page (contact your IT administrator for access details) and locate the corresponding Smart Connect Box IP address using its MAC address.
/nOpen a browser and enter https://[Gateway IP] to log in to the Smart lighting web system. When logging in for the first time, you will need to set a login password. （If you forget your password, you can reset it by using project information including the Project code, Device cloud ID, and Device MAC address. Alternatively, you can restore the Smart Connect Box G2 to factory defaults via a hardware reset.）/n
In the Ethernet Configuration ➔ Change IP setting from DHCP to Static IP ➔ Fill in the required IP address, subnet mask, gateway (from the IT manager) ➔ Click Save to save the changes ;/n
Short press the Reset button with a pin to restart the Smart Connect Box G2. The Smart Connect box will now use the static IP address which was set.`,
    staticipsetinfo6: `If a firewall or security system is in use, please provide the MAC address of each Smart Connect Box G2 to your local IT team.Your local IT will whitelist these MAC addresses, which also helps prevent connection issues in the future./n
    To ensure stable operation of the Smart Connect Box, please open 443 (HTTPS) and 8883 (MQTT). If OPPLE customer service asks you to upload logs to assist with troubleshooting, you will also need to open port 80. Additionally, please ensure access to the domain iotctrl1.opple.com, the cloud server used by the the Smart Connect Box G2.`,
    staticipsetinfo1: 'If there is a firewall/security system, please provide the MAC address(es) of the Smart Connect Box(es) to the local IT. /nThe local IT will whitelist the MAC addresses, this will also prevent future connection issues. /nIf the Connect Box firmware version is less than V87.xx.xx, please open TCP: 80, 443, and UDP: 65501 for the upgrade. After upgrading to V87.xx.xx, the communication protocol will automatically change to TCP: 443 (HTTPS), 8883 (MQTT). After the upgrade, you can close the TCP: 80 and UDP: 65501. Port 80 must be enabled for Smart Connect Box log retrieval. /nAlso, make sure that the domain name iotctrl1.opple.com is allowed, this is the server/cloud that the connect boxes communicates with.',
    finishedDeviceCheck: 'Check the box if comfirmed',
    notAllowGateway: 'Adding this gateway is currently not supported',
    addOnApp: 'Please add configuration on the app',
    deviceInfoError: 'The device is abnormal. Please contact the installer or OPPLE customer service for return or replacement arrangements.',
    g2Tip1: 'LED Indicators Description: ①Status indicator ②LAN indicator ③Internet indicator ④Wi-Fi indicator',
    g2Tip2: 'If the LAN indicator is not lit, check whether the network cable is properly connected to the router. If you need to use a',
    g2Tip3: 'please contact the IT administrator.',
    g2Tip4: 'If the Internet indicator is not lit, please check whether the router has normal internet access, and confirm that the Ethernet or Wi-Fi indicator lights are working properly.',
    g2Tip5: 'If you need to be assigned a',
    g2Tip9: 'Wait until the Status indicator, LAN indicator, and Internet indicator light up, then click Next.',
    g2Tip10: 'Long press and hold the "Reset" button shown in the figure for at least 10 seconds until the Status indicator flashes rapidly, then release the button. The device will perform a factory reset. When the Status indicator turns off, the reset is successful and the device is restarting.',
    g2Tip11: 'Static IP address',
    g2Tip12: 'in the local network to access the internet,'
  },
  findDevice: {
    addgateway: 'Select a Smart Connect Box',
    span: 'Scan',
    step1: 'Select a Smart Connect Box',
    step2: 'Select a connection type',
    step3: 'Scan',
    step4: 'Stop',
    child: 'Connection',
    progress: 'Progress:',
    save: 'Confirm',
    back: 'Back',
    warning: 'Select one connection type',
    finddevicetotal: 'Scan Devices Total',
    countdown: 'Scan countdown:',
    area: 'district:',
    areaNo: 'Code',
    areaNoPlaceholder: 'Please enter the area code',
    group: 'group:',
    groupNo: 'Group number',
    gateway: 'GrantsBay Gateway',
    findDevice: 'Discover the device',
    moveAllDevice: 'By default, all devices are moved into the room, whether or not they are moved in？',
    moveAllDeviceTip: "If you don't move in, you can do it again in the no-zone later.",
    notMoveIn: 'Not moving in yet',
    moveIn: 'Move in',
    gatewayName: 'Enter the gateway name',
    selectDevice: 'Please select a device',
    selectAll: 'Select all',
    remove: 'remove'
  },
  register: {
    account: 'Email',
    password: 'Password',
    surepassword: 'Confirm your password again',
    name: 'Smart lighting project',
    placeholderemail: 'Please fill in your e-mail address',
    emailformate: 'Wrong e-mail format',
    psw: 'Register',
    regis: 'Register',
    info: '（As installer）',
    address: 'Address',
    phone: 'Phone number',
    yanzhneg: 'Verification code',
    finsh: 'Done',
    agreen: 'Read and aceept #the terms/conditions',
    placeholderpsw: 'Please fill in your password',
    moredpsw: 'Please fill in your password again',
    emailr: 'Please fill in your verification code',
    pswr2: 'Please use 6-15 numbers and letters',
    phoneerror: 'Phone Error',
    passnosame: 'The password is inconsistent',
    checkmessage: 'Read and aceept the terms/conditions',
    privacy: 'Privacy policy',
    declaration: '(1) In order to use Opple Intelligent Lighting control system, the user must use an organizational E-mail rather than a personal E-mail.<br>(2) Opple will collect the user’s company E-mail, system preferences and products information only.<br>Opple do not store any user personal information.<br>(3) The information stored by Opple is just to ensure the correct operation of Opple Intelligent Lighting control system.<br> (4) At any time required by the customer, the information stored by Opple can be totally removed. <br>(5) In order to use Opple Intelligent Lighting control system, the user must agree with this terms.<br> II. If the user cancels their account through the “Cancel User” function, the system will delete<br>all information related to this account.<br>For item (4) need II as supplement',
    existingAccount: 'Existing account?',
    countryempty: 'Country/Region Empty'
  },
  header: {
    transProject: 'Transfer Project',
    exit: 'Exit',
    projectname: 'Project Name：',
    editmsg: 'Edit',
    restpsw: 'Reset the password',
    loginOut: 'Logout',
    save: 'Save',
    cancel: 'Cancel',
    language: 'English',
    oldpassword: 'Old password',
    newpassword: 'New password',
    confirmpassword: 'New password again',
    username: 'Name',
    useraddress: 'Address',
    userphone: 'Phone',
    oldpasswarn: 'Fill in old password',
    newpasswarn: 'Fill in new password again',
    twopasswarn: 'Please make sure you filled in the same passwords',
    dosending: 'Sending',
    switchProject: 'Switch Project',
    logOutUser: 'Unregister',
    cancelUserTitle: 'Unregister Account',
    cancelUserOneTips: 'There is only one installer for the above project(s). The project cannot be recovered after deleting it. ',
    cancelUserMoreTips: 'For the security of your account, you can unregister your account only when there are no projects in your account. Please delete the projects or hand them over to others before unregistering. ',
    cancelUserOneDelTips: 'There is only one installer for this project. The project cannot be recovered after deleting it. Are you sure to continue?',
    cancelUserMoreDelTips: 'After unregistration from this project, you will not be able to access it. Are you sure you want to continue?',
    cancelUserOperOneMoreTips: 'Projects which still has devices cannot be deleted and only be transferred. ',
    selected: 'Selected',
    project: 'Item',
    recipientEmail: 'Receiver email:',
    recipientEmailConfirm: 'Confirm email',
    cancelUser: "Confirm that you really want to log off. You can't login after logging out.",
    bindPhoneTitle: 'Binding confirmation',
    unbindPhoneTitle: 'Unbinding confirmation',
    bindPhoneTips: 'After binding, you can use the mobile phone login',
    unbindPhoneTips: 'After unbinding, you will not be able to use the mobile phone to login to the account',
    noBindPhoneTips: 'No Mobile phone',
    noBindEmailTips: 'No Email',
    bindPhoneOpareTips: 'Mobile phone login is not supported on the web',
    transferEmail: 'Transfer to (Email address)',
    recipientPhone: 'Recipient phone number',
    recipientPhoneConfirm: 'Confirm phone number',
    setpsw: 'Set password',
    bindEmailTips: 'After binding is completed, you can use this email address to log in with your account',
    unbindEmailTips: 'After unbinding, you will not be able to use this email address to log in your account anymore.',
    transferPhone: 'Transfer to (Phone number)',
    helpTip: 'Hello, how can I help you?',
    helpDocument: 'Help Documents',
    commonProblem: 'Frequently Asked Questions',
    userGuide: 'User Guide',
    problemType: 'Issue Categories',
    submitter: 'Submitter',
    submitTime: 'Submit time',
    emailFormatMismatch: 'Inconsistent email format',
    phoneNumberMismatch: 'Inconsistent phone numbers'
  },
  sidebar: {
    home: 'Home',
    details: 'Project',
    projectDetails: 'Project',
    management: 'User',
    install: 'Installation',
    monitoring: 'Monitor',
    control: 'Scenes',
    automation: 'Automation',
    systemLog: 'System',
    failureList: 'Alerts',
    ota: 'Upgrade',
    screen: 'Screen',
    otatask: 'Upgrade',
    notices: 'Notices'
  },
  devicelist: {
    treeplaceholder: 'Search',
    warnmove: 'Same area, please choose another area to move to.'
  },
  projectList: {
    liteProjectTip: 'Without Connect Box System Lite',
    projectNum: 'Smart lighting project',
    add: 'Project',
    projectApp: 'Classic Smart Lighting System',
    openApp: 'Please use the Opple Smart Lighting App to open the project',
    name: 'Project name',
    time: 'Creation date',
    people: 'Installer(s)',
    state: 'Status',
    num: 'Devices',
    address: 'Location',
    UserRole: 'Role',
    UserRole1: 'Admin',
    UserRole2: 'Installer',
    UserRole3: 'Manager',
    UserRole4: 'User',
    UserRole5: 'Visitor',
    caozuo: 'Task',
    in: 'Open',
    all: 'Archive',
    modify: 'Modify',
    accept: 'Accept',
    refuse: 'Refuse',
    allcountry: 'All',
    normal: 'Ok',
    malfunction: 'Fault',
    activate: 'Activate',
    delete: 'Delete',
    good: 'Good',
    serachWord: 'Project name',
    fireProject: 'Firefighting Projects',
    comProject: 'Commercial Project',
    standardProject: 'Standard project',
    collection: 'Save',
    unCollection: 'Already saved',
    continueConfiguring: 'Continue configuring',
    notOperable: 'Not operable in standard project configuration'
  },
  projectmsg: {
    storeCode: 'Store Code',
    StoreName: 'Store Name',
    isNo: 'IsNo：',
    placeholder: 'Please enter the',
    fillChannel: 'Please fill in the channel data completely',
    channel: 'Channel',
    projectInfo: 'Project data：',
    span1: 'Project info',
    span2: 'Project details',
    name: 'Project name：',
    type: 'Application：',
    country: 'Country：',
    time: 'Time zone：',
    address: 'Address：',
    img: 'Picture：',
    code: 'Zip code：',
    plhode0: 'Fill in project name',
    plhode1: 'Select project application',
    plhode2: 'Select Country/Region',
    plhode3: 'Select project time zone',
    plhode4: 'Fill in project address',
    plhode5: 'Fill in project zip code',
    plhode6: 'Fill in project type',
    save: 'Save',
    cancel: 'Cancel',
    verificationName: 'Please fill in your project name',
    verificationCountry: 'Please select your country',
    verificationType: 'Please select your application type',
    verificationAttibute: 'Please select your project type',
    verificationTimeZone: 'Please select your timezone',
    verificationWorkTime: 'Please define your working hours.',
    imginfo: 'Image size exceed 2MB!',
    formateerror: 'Wrong image format, please only use jpeg or png files',
    bigerror: 'Image size exceed 2MB!',
    attribute: 'Project type：',
    ledEnergy: 'LED saving：',
    ledEnergyTip: 'Please fill in the LED saving percentage',
    everyWorkTime: 'Working hours：',
    workStartTime: 'Start',
    workEndTime: 'End',
    span3: 'Country Info',
    span4: 'Time zone Info',
    DST: 'DST：',
    DSTTime: 'DST time：',
    DSTTimeTips: 'Please select your DST time',
    DSTTimeShift: 'DST shift：',
    DSTTimeShiftTips: 'Please select your DST shift',
    DSTEnable: 'Enable',
    DSTDisable: 'Disable',
    to: '-',
    startdate: 'Start time',
    enddate: 'End time',
    month: 'M',
    day: 'D',
    countryModifyTips: 'If you modify the project daylight saving time information, it will be synchronized to the device. Are you sure you want to modify it?',
    timeModifyTips: 'If you modify the project time zone information, the information will be synchronized to the device. Are you sure you want to modify it?',
    modbusDocument: 'Modbus File：',
    Meterdata: 'Electricity meter data：',
    ledEnergyError: 'LED saving cannot be greater than 100%',
    projectData: 'Project data:',
    exportIn: 'Import data:',
    exportOut: 'Export data:',
    uploadFile: 'Uploading files',
    downloadFile: 'Download file',
    fireProject: 'Fire Fighting',
    bacnetDocument: 'BACnet File：',
    programList: 'Program list:',
    errorFileTip: 'Wrong format, please re-import the file',
    dataImfo: 'Data message',
    configured: 'Configured',
    unconfigured: 'Unconfigured',
    holidaysConfiguration: 'Holidays Configuration',
    effectiveImmediately: 'Apply Now',
    configurationNote: 'Holidays Instructions',
    holidaysConfigurationTip1: 'Set holidays: Click on a blank date;',
    holidaysConfigurationTip2: 'After clicking “Apply Now” all holiday settings in all automations (including existing automations) will be updated!',
    holidaysConfigurationTip3: 'Cancel holidays: Click on a date that has already been set as a holiday;',
    springFestival: 'Spring Festival',
    tombSweepingDay: 'Tomb Sweeping Day',
    laborDay: 'Labor Day',
    dragonBoatFestival: 'Dragon Boat Festival',
    midAutumnFestival: 'Mid-Autumn Festival',
    nationalDay: 'National Day',
    newYearsDay: "New Year's Day",
    weekEnds: 'weekend',
    pleaseClickToConfigure: 'Please click to configure',
    anyPointInTime: 'Any point in time',
    JSONOnly: 'Only JSON format files are allowed to be uploaded!',
    fileNotExist: 'File does not exist',
    fileReadFailed: 'File read failed',
    jsonFormatError: 'JSON format error, please check the file content',
    uploadValidJson: 'Please upload a valid JSON file',
    resetStandardHolidays: 'Reset to Standard National Holidays',
    clearAll: 'Clear All',
    confirmResetHoliday: 'After resetting, custom holidays will be cleared. Continue?',
    confirmClearAll: 'After clearing, all existing holidays will be cleared. Continue?',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    standardHoliday: 'Standard National Holidays',
    customizeHoliday: 'Custom Holidays',
    useStandardHolidayNextYear: "Extend standard national holidays to next year",
    holidayUpdateSubscription: "Subscribe to holiday update notifications",
    enterEmailAddress: "Please enter your email adress",
    invalidEmailFormat: "Invalid email format",
    fetchError: 'We are currently unable to retrieve holiday information. Please contact the project manager/installer.',
    isAcknowledged: 'Got it.',
    countryChangeHoliday: 'We kindly remind you that as the country information has been updated, it would be helpful to review and save the holiday configuration within the project. Thank you.',
    pleaseSelectAtLeastOneHoliday: 'Please select at least one holiday.',
    updatingTheCountry: 'Should the time zone information be updated automatically when changing the country？',
    electricityPriceSettings: 'Electricity Price Settings',
    pleaseSelectType: 'Please Select Type',
    peakHours: 'Peak Hours',
    offPeakHours: 'Off-Peak Hours',
    normalHours: 'Normal Hours',
    others: 'Others',
    electricityPrice: 'Electricity Price',
    yuanPerKwh: 'Yuan/kWh',
    pleaseCompleteTimePeriodInfo: 'Please complete the time period information',
    startTimeFormatInvalid: 'Start time format must be hh:mm and cannot be 24:00',
    endTimeFormatInvalid: 'End time format must be hh:mm',
    startEndTimeCannotBeSame: 'Start time and end time cannot be the same',
    invalidTimeFormat: 'Invalid time format, please use hh:mm',
    invalidTimePeriod: 'Invalid time period, please reselect the time',
    timePeriodOverlap: 'Time periods overlap, please adjust the time',
    totalDurationExceeded: 'Total duration is 24 hours',
    pleaseConfigureTieredPricing: 'Please configure tiered electricity pricing',
    ratedPower: 'Rated Power (W)',
    powerDataConfiguration: 'Power Data Configuration',
    constantLightIntensity: 'Constant Light Intensity',
    pleaseSetLatitudeLongitude: 'Please set the latitude and longitude in the project details first',
    playlistInformation: 'Playlist Information'
  },
  breadcrumb: {
    sy: 'System',
    home: 'Home',
    Project: 'Project list',
    Archive: 'Archived project list',
    projectMsg: 'Project Info',
    mangeUsers: 'User management',
    addpeople: 'Add user',
    systemlog: 'Devices',
    failureList: 'Fault',
    otaup: 'Upgrade',
    deviceinstall: 'Install',
    scence: 'Scene',
    device: 'Device',
    install: 'Install',
    districtmange: 'Area',
    devicemange: ' Device',
    country: 'Select:',
    adddevice: 'Device',
    addtruegateway: 'Smart Connect Box',
    addvirtualdevice: 'Vir-device',
    findDevice: 'Scan',
    control: 'Control',
    monitoring: 'Monitor',
    ifttt: 'Automation',
    iftttCustomSet: 'Automation Custom Set',
    templates: 'Template',
    scenceMsg: 'Scene',
    operatelog: 'Operate',
    otaTask: 'Upgrade task list',
    duplicateArea: 'Duplicate Area',
    iftttCustomSetPanel: 'Automation Smart Switch',
    mangeQrcode: 'Share',
    addShare: 'Add Share',
    mangeLimit: 'User'
  },
  user: {
    placeholdUserName: 'Please fill in the name',
    type1: 'Installer/Owner',
    type2: 'Manager',
    type3: 'User',
    name: ' User name',
    phone: 'Phone number',
    address: 'Company',
    state: 'Status',
    caozuo: 'Task',
    add: 'Add',
    sendemail: 'Send again',
    limits: 'Role',
    del: 'Delete',
    info: 'Info',
    deltext: 'Are you sure to delete?',
    cancel: 'Cancel',
    yes: 'Yes',
    status: {
      0: 'Invited',
      1: 'OK',
      2: 'Refused',
      3: 'Destroy'
    },
    refuse: 'You have refused this invitation',
    addOne: 'Invite #',
    editInfo: 'Edit Account Information'
  },
  invite: {
    phoneInvite: 'Invite by phone',
    emailInvite: 'Invite by Email',
    phonerequired: "Please enter the invitee's phone number",
    phoneerror: 'Please use the correct format',
    enterEmailCN: "Please enter the invitee's email or phone number",
    inputPassword: 'Enter Password',
    passwordAgain: 'Repeat Password',
    inviteOrCreate: 'Invite/Create',
    createNewUser: 'Create new account',
    inviteSuccess: 'Invited successfully!',
    createSuccess: 'Created successfully!',
    loginNow: 'Invitee can login directly with this account!',
    span: 'Info',
    yaoqing: 'Invite',
    plhode1: 'Please fill in the e-mail address',
    plhode2: 'Please fill in the phone',
    password: 'Please fill in the password',
    span1: 'Invitation sent successfully',
    span2: 'Please remind the invited person to check!',
    span3: 'Back',
    enterEmail: 'Please fill in the e-mail',
    enterLimite: 'Set the role',
    limiteBlock: 'Area',
    finsh: 'Done',
    emailerror: 'Wrong format',
    emailrequired: 'Please fill in the e-mail address or phone',
    passwordMismatch: 'The passwords do not match'
  },
  monitor: {
    clickUpdate: 'Click to upload',
    dapingSetting: 'Settings',
    nameSetting: 'Name Setting',
    backgroundSetting: 'Background Setting',
    serverInfo: 'Server Information',
    haveUsed: 'Used',
    free: 'Idle',
    cpuDetail: 'CPU Information',
    memoryDetail: 'Memory Information',
    diskDetail: 'Disk Information',
    cpuUsedInfo: 'Real-time CPU usage',
    memoryUsedInfo: 'Real-time memory usage',
    showArea: 'Display Area',
    showTime: 'Time Line',
    DefaultAreaRank: 'Default Ranking',
    customSettingRank: 'Custom Level Ranking',
    rankingTitle1: 'Level 1st Area Ranking',
    rankingTitle2: 'Level 2nd Area Ranking',
    rankingTitle3: 'Level 3rd Area Ranking',
    rankingTitle4: 'Level 4rd Area Ranking',
    saveEnergyRank: 'Energy Saving Ranking',
    useEnergyRank: 'Actual Energy Ranking',
    showMore: 'Show more',
    curentDay: 'Today',
    curentWeek: 'This Week',
    curentMonth: 'This Month',
    curentYear: 'This Year',
    curentSeason: 'This Quarter',
    comfort: 'Comfortableness',
    offline: 'Offline',
    online: 'Online',
    open: 'ON',
    close: 'OFF',
    error: 'Fault',
    allcount: 'Total',
    lampcount: 'Total Lights',
    canup: 'Upgrade',
    select: 'Select',
    allpower: 'Total',
    allcomfort: 'Environment comfortableness',
    importup: 'Export',
    realtimepowerconsumption: 'Energy usage',
    comparisonofregions: 'Areas energy comparison',
    selectarea: 'Select Areas',
    agriAreaSelect: 'Region',
    agriSensorTitle: 'Light Sensors',
    agriSensorNatural: 'Natural Light Sensor',
    agriSensorUnderLamp: 'Under-lamp Sensor',
    agriNoDataPlease: 'No data, please',
    agriPositionOutside: 'Outside',
    agriPositionRoof: 'Roof',
    agriPositionUnderLamp: 'Under lamp',
    agriBindSensor: 'Bind Sensor',
    agriRebindSensor: 'Change Binding',
    agriUnbindSensor: 'Unbind Sensor',
    agriLightStatistics: 'Light Statistics',
    agriLampBrightness: 'Lamp Brightness',
    agriTodayNaturalLight: 'Today Natural Light Total',
    agriTodayArtificialLight: 'Today Artificial Light Total',
    agriSupplementDuration: 'Supplement Duration',
    agriTargetProgress: 'Target Progress',
    agriDliTotal: 'Today Light Total (DLI)',
    agriDliNatural: 'Natural Light',
    agriDliArtificial: 'Artificial Supplement',
    agriSensorNaturalValueLabel: 'Current Light Value',
    agriSensorUnderLampValueLabel: 'Instant PAR',
    agriToday: 'Today',
    agriYesterday: 'Yesterday',
    agriLastThreeDays: 'Last 3 Days',
    agriLastMonth: 'Last Month',
    agriLastThreeMonths: 'Last 3 Months',
    agriChartNaturalDLI: 'Natural Light Cumulative',
    agriChartArtificialDLI: 'Artificial Light Cumulative',
    agriChartTotalDLI: 'Total Light',
    agriExportLightRecords: 'Lamp Operation Records',
    agriExportSensorReport: 'Area Bound Agricultural Sensor Data',
    agriExportSelectArea: 'Please select an area first',
    agriExporting: 'Exporting, please wait…',
    hotspacepic: 'Space Utilization',
    ranking: 'Space Utilization Ranking',
    utilizationrate: 'Occupancy percentage = Motion detected time/ Total time',
    devicestatus: 'Status',
    sure: 'Confirm',
    cancle: 'Cancel',
    selectdevicearea: 'Select',
    lasthour: 'Last 24h',
    lastweek: 'Last 7d',
    lastmonth: 'Last 30d',
    lastyear: 'Last Year',
    realtime: 'Realtime',
    onehour: 'Hour',
    warning1: 'Please select one area at least',
    warning2: 'Please select less than 5 areas',
    warning3: 'Please select the device status',
    warning4: 'You can select a maximum of 10 areas',
    warning5: 'You can select at least two regions',
    areapowerline: 'Energy usage',
    time: '',
    spacehottotal: 'Space Utilization',
    haveperson: 'Occupied',
    noperson: 'Unoccupied',
    areazline: 'Energy chart',
    powername: 'Energy',
    nodata: 'No valid data yet',
    nh: 'Energy',
    hotvalue: 'Utilization',
    occupancyActiveButton: 'Show Occupancy Analyse',
    faultDevice: 'Device with Fault(s)',
    systemState: 'System Status',
    systemNormal: 'OK',
    systemDeploy: 'Configuring',
    systemUnusual: 'Error',
    systemDeployTips: 'Device did not finish synchronization.',
    systemUnusualTips: 'System error such as faulty devices exist',
    choose: 'Select',
    realityEnergy: 'Actual',
    realityEnergy1: 'Total Actual',
    todayEnergy: 'Today',
    designEnergy: 'Expected',
    savingEnergy: 'Energy Saving',
    maxEnergy: 'Max',
    minEnergy: 'Min',
    avgEnergy: 'Average',
    ledEnergy: 'LED Saving',
    smartEnergy: 'Smart Saving',
    ledEnergyRate: 'LED Saving rate',
    smartEnergyRate: 'Smart Saving rate',
    totalData: 'Dashboard',
    changeEnergy: 'Change',
    designEnergyTips: 'Designed energy= ∑ⁿ (Light ON time × Light maximum power.',
    smartEnergyTips: 'Smart saving rate = (design energy - actual energy) / designed energy.',
    ledEnergyTips: 'LED saving rate= (total power of original lights - total power of new lights) / total power of original lights.',
    sArea: 'Area Move',
    sConfig: 'Device configuration',
    sConstillumination: 'Daylight configuration',
    sIFttt: 'IFTTT',
    sProject: 'Project Id',
    sRhythm: 'Schedule control',
    sScene: 'Scene control',
    systemTitle: 'Opple Smart Lighting System',
    projectname: 'Project Name',
    projTodayTotalEnergy: "The project's total energy of today",
    dateButtonTxt: 'Please select adjacent 2-48 hours',
    dateButtonTxt1: 'Please select adjacent 2-90 days',
    dateButtonTxt2: 'Please select adjacent 2-60 months',
    dateButtonTxt3: 'Please select adjacent 2-30 years',
    areaname: 'Area',
    areaChoose: 'Choose 2-10 areas for comparison',
    areaContrast: 'Area energy comparison',
    hour: 'Hours',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    configYear: 'Year',
    configMonth: 'Month',
    configDay: 'Day',
    week: 'Week',
    energyAll: 'Total energy',
    accounted: 'proportion',
    energyRate: 'Energy Saving Rate',
    designTotalEnergy: 'Designed Energy',
    realityTotalEnergy: 'Actual energy',
    week1: 'Mon',
    week2: 'Tue',
    week3: 'Wed',
    week4: 'Thu',
    week5: 'Fri',
    week6: 'Sat',
    week7: 'Sun',
    January: 'Jan.',
    February: 'Feb.',
    March: 'Mar.',
    April: 'Apr.',
    May: 'May',
    June: 'Jun.',
    July: 'Jul.',
    August: 'Aug.',
    September: 'Sep.',
    October: 'Oct.',
    November: 'Nov.',
    December: 'Dec.',
    exportConfirm: 'Confirm Export',
    enterLimits: 'Please enter all limits',
    gpNoNotempty: 'GpNo cannot be empty',
    selectAreaName: 'Select Area Name',
    shangHai: 'Shanghai',
    beiJing: 'Beijing',
    guangZhou: 'Guangzhou',
    noAreaPermission: 'Configuration cannot be completed due to missing area permissions. Please contact the administrator to grant the necessary permissions'
  },
  monitorMap: {
    deviceDetail: 'Device Detail',
    childDeviceRelation: 'Device Relation',
    entryIconMonitorMapTip: 'Go to Floor plan',
    entryIconMonitorListTip: 'Exit floorplan monitor',
    equipmentOverview: 'Devices Overview',
    energyManage: 'Energy Management',
    spaceUtilization: 'Space Utilization',
    openOrClose: 'On/Off',
    onlineCount: 'Online Count',
    offlineCount: 'Offline Count',
    alarm: 'Alerts',
    spaceUtilizationShow: 'Space Utilization Display',
    spaceUtilizationRank: 'Space Utilization Ranking',
    percentageRankDesc: 'Descending order by percentage',
    spaceMotionShow: 'Demonstration of Space Occupancy',
    spaceMotionDetail: 'Space Usage Details',
    collapse: 'Fold',
    motionAreaRank: 'Rooms sort by occupied/unoccupied',
    switchSpaceUtilizationSuccess: 'The floorplan mode has been switched to space utilization!',
    switchSpaceMotionSuccess: 'The floorplan mode has been switched to space occupancy!',
    totalDay: "Today's total",
    totalMonth: "This month's total",
    totalYear: "This year's total",
    noBindArea: 'This area is not yet bound, please draw the area in the map first and bind this area.',
    noCurrentImg: 'This area is not in the current drawing, please switch to the drawing.',
    min: 'min',
    max: 'max',
    quarterStart: 'Start of the quarter',
    quarterEnd: 'End of the quarter'
  },
  baoliMap: {
    projectBoard: 'Projects Overview',
    mapMode: 'Floor Plan Mode',
    listMode: 'List Mode',
    defaultSort: 'Default Ranking',
    warnNumber: 'Total Alerts',
    timeEnergy: 'Real-time Energy',
    lightNumber: 'Total Lights On',
    today: 'Today',
    nowYear: 'This Year',
    LightingRate: 'Percent of Lights On',
    entryProject: 'View Project',
    energyConsumption: 'Energy Monitor',
    deviceNumber: 'Total Devices'
  },
  limite: {
    choose: 'Role',
    finsh: 'Done',
    Functional: 'Function',
    index: ' Main page (Not editable)',
    project: 'Project info (Not editable)',
    monitoring: 'Monitor',
    lighting: 'Scenes',
    areaLimit: 'Area',
    movename: 'Area',
    onewarn: 'Please select at least one area',
    ifttt: 'Automation',
    qrcode: 'QrCode',
    install: 'Installation',
    failureList: 'Alerts',
    waring: 'The # will be able to add, delete, move and replace devices.',
    waring1: 'You will grant # the authority to manage devices.',
    ok: 'Yes',
    cancel: 'Cancel'
  },
  adddevice: {
    maintenance: 'Device capability under maintenance, please try again later!',
    add: 'Add',
    back: 'Back',
    move: 'Move',
    addto: 'Add',
    realdevice: 'Device',
    realgateway: 'Smart Connect Box',
    virtualthirdparty: 'Vir-3rd party',
    virtualdevice: 'Vir-device',
    virtualgateway: 'Vir-Smart Connect Box',
    realthirdparty: '3rd party',
    ethernet: 'Ethernet Device',
    findQcode: 'Please find the QR code at the back of product',
    teleQcode: 'Use the phone to scan the QR code to get the 80-bit strings',
    example: 'For example',
    enoceanInfo: 'The red part is the Mac address of this device and the green part is the repeater key.',
    copyInsert: 'Copy the entire 80-digit string to your computer and fill in the corresponding location.',
    selectDeviceType: 'Select device type',
    enterDeviceName: 'Enter the device name to search',
    MacAddress: 'Mac Address & Key',
    findString: 'How to find the string?',
    qcString: "Please enter the string of the product's QR code on the label on the back of the product",
    retry: 'Re-select',
    configure: 'Go to Configure',
    failDevice: '1 device failed to be added, please check whether the character string is correct.',
    successDevice: 'Added successfully, to ensure the  use the device normally, it is necessary to select the light as the repeater node, please go to the device details page to set.',
    midConfig: 'Repeater Configuration',
    secret: 'Key',
    noDevice: 'No device',
    requires32characters: 'Requires 32 characters',
    moveTitle: 'Would you like to move all devices into this room by default? If you prefer not to move them now, you can do so later in the unassigned area.',
    movebnt1: 'Do not move now',
    movebnt2: 'Move in',
    addMaxDeviceTitle: 'Support to add up to {{max}} devices',
    noDeviceTitle: 'There is no lights to be set repeater nodes or their firmware version is too low, you need upgrade first then set it as repeater node.',
    noAddTitle: 'There is no connect box to support this function, or its firmware version is too low, need to be upgraded before pairing.',
    addSuccess: 'Added successfully!',
    outRang: 'Out of range',
    least: 'At least',
    upTo: 'At most',
    subDevice: 'Gateway sub-device',
    tianmu: 'Tianmu'
  },
  courseDataySync: {
    current: 'Synchronization status',
    history: 'Synchronization status',
    title: 'Synchronization',
    error: 'Synchronization status',
    tipInfo: 'By default, the device will be moved into this room. Are you sure?',
    reset: 'Reset'
  },
  tree: {
    exportExcel: 'Import area tree from excel file',
    downloadTemplate: 'Download  the template',
    excelInfo: 'If you have not edited the area tree, download the template and edit it according to the format',
    excelTemplateName: 'Area tree template',
    uploadTemplate: 'Upload',
    uploadType: 'Only support .xlsx and .xls file',
    moveHere: 'Drag and drop files here to replace',
    title: 'Control node',
    replaceExcel: 'Replace file',
    uploadTime: 'Upload time',
    plhode1: 'Search',
    updatewaring: 'Please finish your current task first',
    city: 'Area Tree',
    placeholdertree: 'Search',
    submit: 'Yes',
    cancle: 'No',
    delmsg: 'Are you sure to delete the area？',
    addmsg: 'Name',
    treeMenuShowTip: 'Tree Area Collapse',
    selfArea: 'Self',
    subArea: 'Sub',
    nopermission: 'No permission for the selected area. The area information cannot be displayed. If needed, please contact the administrator to add the required permissions.'
  },
  scene: {
    singleDeviceOne: 'Only one Scene can be selected for a single device',
    singleDevice: 'Single device Scene',
    onlyQuerySingle: 'Only query single device Scene',
    queryNonSingle: 'Query non single device Scene',
    allScenarios: 'All Scene',
    sceneNo: 'Scene No',
    masterControl: 'Master control',
    partialControl: 'Partial Control',
    tianmuNoGo: 'The Sky Ceiling scene is not editable',
    noFade: 'Fade disabled',
    question: 'The DALI device does not support scene fade time',
    deviceTypes: 'Please select the device protocol type',
    bluetooth: 'BLE',
    converter: 'BLE-DALI Converter',
    sceneSelect: 'Select scene',
    searchPlhode1: 'Scene name/keyword',
    lastScene: 'Last activated scene Excecution time',
    lastSceneTime: 'Operation time',
    lastSceneNone: 'No scene to excute',
    title: 'Scene',
    plhode2: 'Name/Mac',
    plhode1: 'Name',
    add: 'Scene',
    adddevice: 'Add device',
    caozuo: 'Task',
    remove: 'Move',
    del: 'Delete',
    dele: 'Delete',
    power: 'Set the max power',
    cancel: 'Cancel',
    all: 'None',
    allno: 'All',
    powerinfo: 'The max power is',
    yes: 'Confirm',
    state: 'Status：',
    block: 'Area：',
    go: 'Execute',
    deltext: 'Are you sure to delete?',
    ok: 'Yes',
    control: 'Control All',
    controlsingle: 'Control',
    device: 'Device',
    gateway: 'Smart Connect Box',
    deviceSelect: 'Select the device',
    selectScence: 'At least 1 scene need to be selected',
    blockSelect: 'Choose an area',
    roomwarn: 'The action could only be done in the room level',
    areawarn: 'The action could only be done in the area level',
    powerOnInitState: 'Set power on dim',
    lampGradual: 'Set fade time',
    lampLinkagePanel: 'Set the switch to control the lights',
    sensorExtTime: 'Set the sensor delay time',
    powerOnInitStateInfo: 'Dim',
    lampGradualSwitchInfo: 'Device fade function',
    lampGradualExtimeInfo: 'The device fade time is',
    sensorExtTimeInfo: 'The sensor delay time is',
    blockSelectLimitTips: 'Tip: Currently, you can only select #5# regions at most!',
    blockOneSelect: 'Choose one area',
    blockMoreSelect: 'Choose Multiple Areas',
    gatewayDeleTip: 'The deleted device contains a gateway. After the gateway is deleted, the device under the gateway will also be deleted.',
    batchResetInfo: "Set reset mode to",
    batchResetTypeNormal: 'Normal mode',
    batchResetTypeExpert: 'Professional mode',
    batchReset: 'Set reset mode',
    batchConfigurePowerOnState: 'Set power on status',
    PowerOnState: 'power-on status',
    PowerOnStatePrecious: 'last status',
    PowerOnStateFixed: 'fixed status',
    open: 'open',
    close: 'close',
    selectSceneToCopy: 'Copy the scene',
    lightCount: 'LED Block Counts',
    areaMapping: 'Please configure the region mapping first before executing the scene',
    goConfig: 'Go configure it',
    projectConfig: 'Project Configuration',
    batchConfig: 'Batch Configuration',
    batchCLO: 'Set CLO parameter',
    DaliSulv: 'Set the DALI fade rate',
    batchCLOTips: 'CLO Parameter',
    setBatchCLO: 'Set CLO Parameter',
    NoFadeSupport: 'The following devices do not support the [Fade Duration] feature.Please change the fade duration to the default setting.',
    FadeSupportAfterUpgrade: 'The following devices support the fade duration feature after the upgrade',
    WebImageScene: 'Web Image Scene',
    defaultFadeByScene: 'The default state follows the device fade duration set in the scene configuration',
    fadeTime: 'Fade Time',
    sensorSensitive: 'Set sensor sensitivity',
    sensitivity: 'Sensitivity',
    batchRename: 'Batch Rename Channels',
    LevelPerSecond: '{num} Steps/s'
  },
  tianmu: {
    minutes: 'minutes',
    onlyOneTime: 'Only one device can be selected',
    devicePlaying: 'Device Playing...',
    paused: 'Paused',
    times: 'times',
    onlyFiveVedio: 'Only 5 videos are supported. If you want to continue uploading, please delete other videos first',
    noSolution: 'No solution found',
    noDownloadedVideo: 'No downloaded video available. Continue playback is unavailable.',
    estimate: 'estimate',
    clickToRetry: 'Click to retry',
    static: 'static',
    dynamic: 'dynamic',
    noVideo: 'No video scene selected',
    customEditing: 'Custom Editing',
    equipmentSchematic: 'Equipment schematic diagram',
    schemeAccepted: 'Scheme accepted',
    chooseNumber: 'choose one of the $$',
    multipleChoice: 'Multiple choice',
    master2: 'two',
    master3: 'three',
    master4: 'four',
    master5: 'five',
    notSupported: 'not supported',
    maxSizeUniform: 'Maximum size is {max}m',
    maxSizeSides: 'Requirements: one side ≤ {maxLong}m, the other side ≤ {maxShort}m',
    minSizeUniform: 'Minimum size is {min}m',
    minSizeLampSides: 'Requirements: one side ≥ {minLong}m, the other side ≥ {minShort}m',
    circle: 'Circle',
    radius: 'radius',
    irregular: 'Irregular',
    moduleMatch: 'Module Matching',
    launchDate: 'Launch Date',
    shapeSelection: 'Shape Selection',
    sdlModule: 'SDL Module',
    sdlModuleSingle: 'Single module (75*75mm)',
    sdlModuleCombo: 'Auto-match optimal tiling (75*75mm, 100*600mm, 600*600mm)',
    lampModule: 'Luminaire Module',
    lineModule: 'Linear Module',
    faceModuleTooltip: 'Integrated design for large-area installation on walls, ceilings, floors, and more',
    lampModuleTooltip: 'Built for diverse space lighting needs. Supports standalone single-module installation and free multi-unit assembly for walls, ceilings, floors, and other areas',
    lineModuleTooltip: 'Practical and design-oriented. Ideal for office corridors, hotel linear décor, retail border lighting, and public wayfinding—creating clean, extended linear light effects',
    uploadDrawing: 'Upload Drawing',
    windowShadow: 'With window shadow',
    noWindowShadow: 'Without window shadow',
    singleOffset: 'Single offset',
    doubleOffset: 'Double offset',
    directDown: 'Direct down',
    lockedConfiguration: 'Locked configuration',
    ceilingCurtainDevice: 'Ceiling Curtain Light',
    Row: 'Row',
    Column: 'Column',
    layout: 'Layout',
    mainDevice: 'Master',
    slaveDevice: 'Slave',
    testDescribe: 'Test Description',
    InstallationDiagram: 'Installation and Wiring Diagram',
    power: 'Power',
    square: 'Square Shape',
    ceilingCurtain: 'Ceiling Curtain Light Configuration',
    lineDir: 'Wiring Direction',
    lightSources: 'Spacing between adjacent light sources',
    lightSourceDistribution: 'Light Source Distribution',
    lineMap: 'Overall Wiring Diagram',
    a3Info: 'For printing drawings, it is recommended to use A3 size with color printing.',
    constructionDepth: 'Construction Depth',
    solutionModuleInvalid: 'Current length and width exceed this module’s range.',
    solutionModuleMinInvalid: 'Current length and width are below this module’s range.',
    realPhotoProduct: 'Actual Product Specifications',
    realPhoto: 'Actual Effect',
    thicknessDeep: 'Thickness (groove depth)',
    specifications: 'Specifications',
    exportsing: 'Exporting: Please wait patiently, this may take some time',
    installation: 'Installation requirements',
    canvasInfo1: 'The SDL light sources shall be evenly arranged according to the drawing requirements, with consistent spacing between adjacent light sources',
    canvasInfo2: 'The ceiling trough must be constructed with wooden boards and painted white. The trough depth shall be $$ mm, and the interior must be dust-proofed, with no unnecessary holes or gaps.',
    canvasInfo3: 'The access panel for the driver and controller must be located near the ceiling curtain, with power cables pre-installed.',
    canvasInfo4: 'The distance between the driver and the optical module shall not exceed 5 meters, and the cable must be 1.0 mm² or larger.',
    canvasInfo5: 'When a single circuit has more than 80 pixels, additional power injection at both ends is recommended.',
    designerTools: 'Designer Tools',
    skyCeilingDesign: 'Sky Ceiling Design',
    pointPreview: 'Point Preview',
    faceModule: 'Surface Module',
    workbenchZoomDrawing: 'Zoom Drawing',
    workbenchFilmLimit: 'Film Limit',
    workbenchFilmLimitValue: '4.2m',
    myDesigns: 'My Designs',
    createNewDesign: 'Create New Design',
    share: 'Share',
    viewDetails: 'View Details',
    designName: 'Design Name',
    placeholderDesignName: 'Please enter a design name',
    createShape: 'Create Shape',
    specSettings: 'Specification Settings',
    width: 'Width',
    thicknessSlotDepth: 'Thickness (Slot Depth)',
    maintenanceHatchPosition: 'Maintenance Hatch Position',
    systemSettings: 'System Settings',
    systemRecommend: 'System Recommended',
    shortSide: 'Short Side',
    longSide: 'Long Side',
    effectPreview: 'Effect Preview',
    maintenanceHatch: 'Maintenance Hatch',
    lightDensity: 'Light Source Density',
    selectControllerType: 'Select Controller Type',
    singleChannelController: 'Single Channel Controller',
    dualChannelController: 'Dual Channel Controller',
    previewSceneLibrary: 'Preview Scene Library',
    export: 'Export',
    lightSourceInfo: 'Light Source Information',
    billOfMaterials: 'Bill of Materials',
    lightDistributionDrawing: 'Light Distribution Drawing',
    view: 'View',
    area: 'Area',
    lightingBlockchainCount: 'Number of Lighting Blocks',
    controllerCount: 'Number of Controllers',
    powerSupplyCount: 'Number of Power Supplies',
    maxPower: 'Maximum Power',
    productName: 'Product Name',
    partNumber: 'Part Number',
    description: 'Description',
    quantity: 'Quantity',
    inputSpec: 'Input Specification',
    generateSolution: 'Generate Solution',
    previousStep: 'Previous Step',
    complete: 'Complete',
    nextStep: 'Next Step',
    exit: 'Exit',
    bluetooth: 'Bluetooth',
    imagesOnly: 'Images-only',
    imagesAndVideosOnly: 'Supports image and video scenes',
    canopyMaxLengthNotice: 'A single canopy supports a maximum length of 15m. Lengths over 15m will be segmented',
    canopyMaxWidthNotice: 'A single canopy supports a maximum width of 4.2m. Widths over 4.2m will be segmented',
    maintenancePortInstruction: 'The system will automatically recommend the optimal location',
    lightDensityDescription: 'The higher the light source density, the finer the scene details, but the cost is also slightly higher',
    high: 'High',
    middle: 'Middle',
    low: 'Low',
    delete: 'Delete',
    size: 'Size',
    nameLengthLimit: 'The name cannot exceed 15 characters',
    nameRequired: 'Please enter a name',
    shuangluPoint: 'The actual number of points {{num}} does not match the current number of points',
    oneKeyUpLevel: "One-click Upgrade",
    childDevice: "Child Device",
    lightLibrary: "Lighting Effects Library",
    upImageTip: "Tip: The image will be adaptively stretched based on the device size.",
    customizeName: "Custom Name",
    configTip: "Configuring, please try again later.",
    unbindTips: "After unbinding the solution, all associated child devices will be removed, and related scenes and automations will be cleared. Are you sure you want to continue?",
    reBuildTips: 'After redrawing the point position, related scenes and automations will be cleared. Are you sure you want to continue?',
    delTips: "After deleting the device, all associated child devices will be unbound, and related scenes and automations will be cleared. Are you sure you want to continue?",
    delTips2: "The devices to be deleted include skylight devices. After deletion, all associated child devices will be unbound, and related scenes and automations will be cleared.",
    channelCount: 'Channel Count',
    pointCount: 'Points',
    addTianmuDevice: 'Add Tianmu Device',
    guanlian: 'Associate',
    bindPlan: 'Bind Plan',
    bindDevice: 'Bind Device',
    bindPlanTitle: 'Please select a plan under the current account',
    bindDeviceTitle: 'Please select the device to be bound',
    bindDeviceWarning: 'Please select the device to be bound',
    shareWarning: 'Please enter recipient contact information',
    shareWarning1: 'Please enter a valid phone number format',
    shareWarning2: 'Please enter a valid email format',
    successMsg: 'Share successful',
    shareTitle: 'Tianmu Design Plan Sharing',
    notice: 'Notification',
    sizeDesignNotAllowed: 'Size cannot be designed',
    chooseOneOfTwo: 'Choose one of two',
    uploadVideo: 'Upload video',
    videoSize: 'MP4 format, size within 150M, duration not exceeding 1 minute',
    onlyMp4Format: 'The file format is not supported',
    onlyVideoSize: 'The file size exceeds 150M',
    onlyVideoTime: 'The file duration exceeds 1 minute',
    importVideo: 'Import video',
    upVideoTip: 'The video will stretch adaptively according to the device size.',
    overflowTip: 'The scene is full. Please delete an item and try again.',
    sure: 'Sure',
    configurationSchemeCannotDelete: "The scheme in the configuration cannot be deleted.",
    maxScenesLimit: 'Only 5 video scenes can be delivered.',
    productModel: 'Product Model',
    controllerType: 'controller type',
    createStandard: 'Create standard product plan',
    standard: 'Standard Product Solution',
    office: 'office',
    addDescription: 'Please add a description.',
    aiCreate: 'AI is rendering...',
    atUploading: 'Uploading...',
    historyList: 'History',
    uploadFailed: 'Loading failed, please try again.',
    qualityLight: 'Premium Lighting',
    UploadIorV: 'Upload Image / Video',
    aiCreateTip: 'Share your creative ideas or interesting images to generate exclusive AI light effects!',
    sceneDescription: 'Please enter a light effect description, e.g.: Morning sunlight, Afterglow of sunset.',
    myCreation: 'My Creations',
    enterNow: 'Enter Now',
    newConversation: 'New conversation',
    aiCreating: 'AI is currently being generated',
    aiFailed: 'AI generation failure',
    imageEditing: 'image editing',
    generatedImage: 'generated image',
    devicePreview: 'Device Preview',
    saveToMyCreations: 'Save to My Creations',
    picHasSaved: 'The image has been saved to My Creations',
    creativeDescription: 'Please input your creative description',
    sunsetGlow: 'sunset glow',
    snowCcovered: 'snow-covered',
    groupSpacing: 'Group Spacing',
    addArray: 'Add Array',
    arrayInfo: 'Array Information',
    arrayN: 'Array {n}',
    duplicateArrayLength: 'Length {length} already exists. Please choose another length',
    lineLightLength: 'Linear Light Length',
    arrayCount: 'Array Quantity',
    densityModalDesc: 'Higher light source density increases wall illuminance and also cost',
    implementationSpec: 'Real Product Specifications',
    highDensity: 'High Density',
    middleDensity: 'Medium Density',
    lowDensity: 'Low Density',
    radiusLessThanMaxLen: 'Radius must be greater than the maximum array length {maxLen}m',
    radiusRequired: 'Radius cannot be empty and has been reset based on the array configuration',
    circleArrayEmpty: 'Please add array information, then click “Apply” for point preview',
    arrayRequired: 'Linear light array information cannot be empty',
    arrayFieldRequired: 'Linear light length or array quantity cannot be empty',
    arrayApplyRequired: 'Please click “Apply” first to generate the point preview',
    arrayLayoutInvalid: 'Array layout validation failed. Please adjust and try again',
    wellSky: 'Well Sky',
    xidingDeng: 'Ceiling Light',
    canDiao: 'Dining Light',
  },
  sceneTemplate: {
    warningTemplateTextAuto1: 'Please check if there are any lights in the current area.',
    warningTemplateTextAuto2: 'Please check if there are any sensors or switches in the current area.',
    warningTemplateTextAuto3: 'If conditions 1 and 2 are met but there is still no data, this indicates that no templates are currently available.',
    picScene: 'Image Scene',
    titleFreePic: 'Temporarily free！',
    title: 'OPPLE Scene template',
    scheme: 'Solution',
    preView: 'Preview',
    sure: 'Sure',
    finished: 'Succeeded',
    application: 'Apply',
    noMatchedDevice: 'Unmatched devices',
    selfDefine: 'Customized scenes',
    templateDefine: 'Quick scenes',
    warningText: 'There are no supported devices in your selected area, please add a device or select a area with a device first, then use the scene template!',
    warningTemplateText: 'There is no scene template in the area you selected!',
    autoTitle: 'Automation Template',
    warningTextAuto: 'There is no sensor in this area. Please add a sensor in order to use the templates.',
    warningTemplateTextAuto: 'There are currently no templates in the space you have selected.',
    lightTripDefine: 'Light Strip Display Scene',
    copyScene: 'Copy scene',
    tianmu: 'Sky Secne',
    sceneEffectPreview: 'Preview Scene',
    selectImg: 'Please select template or custom image, then upload the image.',
    imageTemplate: 'Image template',
    customUpload: 'Upload the custom',
    morning: 'First Light of Dawn',
    silentNight: 'Tranquil Nightfall',
    blueSky: 'Blue sky and white clouds',
    blueSkySun: 'Blue sky, white clouds and sun',
    holiday: 'SunKissed Reverie',
    sunsetGlow: 'Crimson Dusk',
    sunset: 'Twilight Glow',
    risingSun: 'Ascendant Sun',
    noNeedPath: 'No need  to draw a path in the current circular scene',
    needPath: 'In the  current rectangular scene, please draw a path before saving!',
    lightTripInputLampCount: 'Please enter the number of lights slice per line, separated by ",", for example',
    createImageScenes: 'Create a picture scene',
    chooseDevice: 'Select the devices to be adjusted',
    tianmu2: 'Canopy',
    blueSkyLamp: 'SDL Skylights',
    selectStyle: 'Select the style',
    selectLampType: 'Select fixture type',
    select4: 'Please select 4 pieces',
    lightingParameters: 'Light Parameters',
    lampMode: 'Light Mode',
    selectColor: 'Color Selection',
    limit: 'Picture in jpg/png format up to 3M byte',
    screenSplicing: 'Screen Splicing',
    splicing: 'Splicing',
    noSplicing: 'Not Spliced',
    originalImage: 'Original',
    sdlColor: 'SDL Color',
    lightTripOption: 'Parameters Of The Light Strip',
    shadowEffect: 'Shadow Effect',
    clearSky: 'clearSky',
    dawn: 'dawn',
    twilightGlow: 'twilightGlow',
    blueSkyWhiteClouds: 'blueSkyWhiteClouds',
    rainbowAfterRain: 'rainbow',
    spring: 'spring',
    summerScenery: 'summer',
    cleanSweep: 'cleanSweep',
    winter: 'winter',
    blueSkyA: 'Blue SkyA',
    blueSkyB: 'Blue SkyB',
    synthesis: 'Merge more lights',
    row: 'Number of rows',
    col: 'Number of columns',
    Round4in1: 'Round4in1',
    customSize: 'Custom Size'
  },
  devicecard: {
    deviceAndChanel: 'Devices&Channels',
    offline: 'Offline',
    online: 'Online',
    callpolice: 'Alarm',
    malfunction: 'Fault',
    lifeto: 'Lifespan over',
    attributes: 'Attributes',
    area: 'Area',
    switchstatus: 'On/Off Status',
    light: 'Luminance',
    colortemperature: 'Color temperature',
    illuminance: 'Illuminance',
    temperature: 'Temperature',
    movement: 'Occupancy',
    humidity: 'Humidity',
    co2: 'CO2',
    pm: 'PM2.5',
    power: 'Power',
    energyconsumption: 'Energy Consumption',
    remaininglife: 'Remaining lifetime',
    motortravel: 'Level',
    electricity: 'Energy Consumption',
    motorangle: 'Degree',
    dataing: 'Data sychronising',
    identification: 'Identify',
    plank: 'Current dashboard',
    selected: 'Selected',
    info: 'Info',
    sameUnmoved: 'You cannot move the device to the same area',
    delDeviceInfo: 'Please delete the device from the Installation page.',
    alreadycheck: 'Checked',
    nobind: 'Virtual',
    dowarn: 'Info',
    refresh: 'Refresh',
    ok: 'Yes',
    cancel: 'Cancel',
    nonametip: 'Name cannot be empty',
    deviceTotal: 'Devices',
    gatewayTotal: 'Devices',
    identifNone: 'This device is a low power consumption device, please refer to the product guide to identify it.',
    identif1: 'As shown in the figure, simultaneously press the "ON" button on the front of the panel and the "R" button on the bottom side. At this time, the LED indicator light is always on, and the device enters a waiting for upgrade state',
    identif2: 'Please press the reset button of the smart sensor once',
    identif3: '',
    noComma: 'The name contains illegal characters "#,#". Please delete them before submitting'
  },
  sceneCard: {
    mode1: 'Mode1',
    mode2: 'Mode1',
    mode3: 'Mode1',
    mode4: 'Mode1',
    mode5: 'Mode1',
    mode0: 'None',
    state: 'Status：',
    block: 'Area：',
    go: 'Execute',
    base: 'Info',
    cao: 'Task',
    add: 'Add',
    type: 'Type',
    name: 'Name：',
    alreadydelete: 'Deviece has already been deleted',
    alreadymove: 'Deviece has already been moved',
    save: 'Save',
    back: 'Back',
    unifiedcontrol: 'Control All',
    up: 'Go up',
    down: 'Go down',
    lightSwitch: 'Off/On',
    colorWarm: 'CCT',
    color: 'RGB',
    light: 'Brightness',
    openLight: 'ON',
    closeLight: 'OFF',
    selected: 'Selected',
    configuration: 'Configuring',
    allsuccess: 'All succeeded',
    onesuccess: 'Partially succeeded',
    allfail: 'All failed',
    invalid: 'Invalid',
    select: 'Select',
    all: 'All',
    clear: 'Clear',
    sceneId: 'ID：',
    joinYes: 'Enable',
    joinNo: 'Disable',
    dim: 'Step Dim',
    dimmingDown: 'Dim Down',
    dimmingUp: 'Dim Up',
    cct: 'Step CCT',
    cctWarm: 'Warmer',
    cctCold: 'Cooler',
    selectDevice: 'Select Device',
    readReprot: 'Read',
    expandDeviceList: 'Expand Device List',
    allon: 'All',
    alloff: 'All',
    lightTripImg: 'Light Strip Scene Information',
    lightTripRankImg: 'Light Strip Arrangement',
    lightTripCanvasInfo2: 'Select a light strip and draw it in the center edit area.',
    lightTripCanvasInfo3: 'When drawing multiple strips, try to keep the strips aligned as evenly as possible.',
    lightTripCanvasInfo4: 'Ensure that all light strips are drawn within the graphic area.',
    lightTripCanvasDraw: 'Drawing Paths',
    lightTripCanvasEdit: 'Edit Path',
    lightTripCanvasDelete: 'Delete Path',
    lightTripCanvasBack: 'Retract Path',
    lightTripRightAngle: 'Right-angle Mode',
    lightTripCanvasDrawInfo: 'When activated, left-click to add an anchor point and right-click to end the drawing.',
    lightTripCanvasEditInfo: 'When activated, the mouse can drag the line segments in the path.',
    lightTripCanvasDeleteInfo: 'When activated, you can delete the currently selected path.',
    lightTripCanvasBackInfo: 'When activated, retract the path one step',
    size: 'size',
    lightTripInputLampCount: 'Please enter the number of LED count',
    lightCount: 'LED Block Counts',
    line: 'line',
    circle: 'circle',
    senceWarning: 'Before saving, please adjust the device status to match the page!',
    noEdit: "Current scene doesn't support the edition function.",
    noCopy: "Current scene doesn't support the copy function.",
    workStatus: 'State of work',
    sceneNumber: 'Situation number',
    sensor: 'induction',
    alwaysOpen: 'Always open',
    alwaysClose: 'Always off',
    sleep: 'dormancy',
    leastOne: 'Keep at least one device',
    noAvailableDevice: 'No available devices',
  },
  install: {
    configTip: 'Configuration Tips',
    measuringDeviceTip1: 'After the device is connected, please follow the steps below to configure the areas and objects of the metering tool.',
    measuringDeviceTip2: 'Click ‘Parameter Configuration’ on the monitoring page.',
    measuringDeviceTip3: 'Configure the statistics area and object of the device in ‘Energy Statistics Configuration’.',
    deviceHasAtRoom: 'The device is already in this room',
    otaToolTip: 'RSSI',
    otaTipTitle1: 'Please update the below device(s) to the latest firmware before moving and using!',
    otaTipTitle11: 'After a succesful update:',
    otaTipTitle12: '1. Go to "non-assigned area" within the "installation" tab on the left.',
    otaTipTitle13: '2. Scroll down in the area tree/room structure and click on "non-assigned area".',
    otaTipTitle14: '3. Move the devices by using "task" on the right upper corner',
    otaTipTitle15: '4. Select the devices and click on move.',
    otaTipTitle2: 'Please go to Google play or Apple store to download the OPPLE smart lighting App.',
    otaTipTitle3: 'It is recommended to upgrade to the latest firmware and then move.',
    otaTipTitleBatchAll: 'The following # devices need to be upgraded to the latest firmware! Please go to the upgrade task to check the upgrade progress.',
    otaTipTitleBatch: 'After a succesful update:',
    otaTipTitleBatch1: '1. Go to "non-assigned area" within the "installation" tab on the left.',
    otaTipTitleBatch2: '2. Scroll down in the area tree/room structure and click on "non-assigned area".',
    otaTipTitleBatch3: '3. Use the ‘One-click Move’ button in the upper right corner to move all devices marked in the room to the target room.',
    otaTipTitleBatch4: '4. Or use the ‘Task - Move’ button in the upper right corner to move all selected devices to the target room.',
    toWebTip: 'Go to web upgrade',
    toAppbTip: 'Go to App upgrade',
    continue: 'Continue',
    getInfo: 'GOT IT',
    deviceType: 'Device type',
    protocol: 'Connection type',
    typeAname: 'Name/Mac',
    choose: 'Select',
    remveblock: 'Move',
    finsh: 'Finish',
    devicecounterror: 'Select one device',
    areacounterror: 'Select one area',
    loading: 'Loading',
    noarea: 'None-assigned device(s)',
    truegateway: 'Smart Connect Box',
    truedevice: 'Device',
    powerwarn: 'Please fill in a valid number (>0)',
    slelectModifyNameCaption: 'Quick Select',
    deviceFilter: 'Device Filter',
    deviceStatus: 'Status',
    duplicateAreatips: 'Please delete the scene and automation of the target area before performing the copy operation',
    duplicateNativeTipInfo: 'Introduction',
    duplicateNativeTipSelectAre: 'Source Area',
    duplicateNativeTipBind: 'Copy',
    duplicateNativeTipMain: 'Finish',
    duplicateNativeInfo: 'Please make sure the preconditions are in place before you start this step:',
    duplicateNativeInfo1: 'The target area should contain devices that are the same device type and have identical device names as in the source area.',
    duplicateNativeInfo2: 'The scenes and automations in the source area should not contains devices which have been moved or deleted.',
    duplicateNativeInfo3: 'Please delete the scene and automation of the target area before performing the copy operation.',
    duplicateNativeInfoConfirm: 'The above conditions have been confirmed',
    duplicateStart: 'Duplicate',
    duplicateTargetArea: 'Target Area',
    duplicateSourceArea: 'Source Area',
    duplicateArea: 'Duplicate',
    duplicateBindErrorTip: 'The devices in the target area do not have the same number/name/type as the devices in the source area. Unable to proceed to the next step.',
    duplicateBindRelaErrorTip: 'The device mapping relationship is incorrect',
    duplicateInfo1: 'It is possible to have more devices in the target area, but not less compared to the source area.',
    duplicateInfo2: 'The devices in the target area do not have the same name/type as the devices in the source area. Unable to proceed to the next step.',
    duplicateInfo3: 'The devices in the target area are less than the devices in the source area. Unable to proceed to the next step.',
    duplicateInfo4: 'The devices in the scenes/automations match with the current room settings. You can continue to the next step.',
    duplicateInfo5: 'The devices in the scenes/automations have been moved/deleted. Unable to proceed to the next step. Please correct the scenes/automations in the source area first.',
    sceneNumberConfig: 'Scenario setup',
    sceneNumberCount: 'Scenario ID Quantity:',
    inputTip: 'enter content',
    areaMapping: 'Zone mapping',
    sceneConfig: 'Scenario configuration',
    duplicateAreaNumber: 'There are duplicate area codes, please check them before saving',
    doNotShowThisAgain: 'Do not show this again',
    deviceAdded: 'A total of # devices have been successfully added.',
    addResult: "In this session, # devices were added. # devices have been successfully moved to the target room. The remaining # devices require firmware updates before they can be moved. Please click 'Finish' to proceed with the update in the ’Non-assigned area‘. Once the update is complete, these devices can be moved. If you wish to continue adding devices, please click 'Continue'",
    forceUpgrade: 'Forced upgrade',
    batchUpgrade: 'One-click Upgrade',
    batchMove: 'One-click Move',
    moveOnlyMarked: 'Only devices marked with the target room and upgraded to the latest firmware version can be moved using the "One-Click Move" feature.',
    noUpgradableDevices: 'No devices available for upgrade at present',
    movableDevices: 'No devices available for moving.',
    overwriteTargetWarning: 'The target room marked for the device will be overwritten. Please confirm whether to proceed?',
    targetArea: 'Target room',
    aiTokenFailed: 'Failed to get AI token',
  },
  deviceVirtual: {
    span: 'Add Device',
    header: 'Select Gateway',
    nextstep: 'Step',
    wifitype: 'Select',
    nolinewifi: 'Wifi Gateway',
    devicetype: 'Type',
    placeholderone: 'Select',
    placeholdertwo: 'Input Name',
    yes: 'Yes',
    addwifi: 'Add Gateway',
    devicetypewarning: 'Select Type',
    wifitypewarning: 'Select Gateway',
    gatewayerror: 'Please add a Smart Connect Box first',
    xylx: 'Select Type'
  },
  deviceMsg: {
    wait: 'Waiting...',
    resetRelayDevice: 'Reset the relay device.',
    lightMode1: 'Radiant Daylight',
    lightMode2: 'Kaleidoscopic Glow',
    lightMode3: 'White Light',
    lightMode4: 'Pure Color',
    lightMode5: 'music',
    area: 'Area',
    basicinformation: 'Device info',
    devicename: 'Name',
    devicetype: 'Type',
    devicestatus: 'Status',
    online: 'Online',
    offline: 'Offline',
    agreementtype: 'Connection type',
    mac: 'MAC address',
    deviceclassification: 'SKU',
    deviceclassificationname: 'Device type',
    cloudid: 'Cloud ID',
    virtualid: 'Vir-cloud ID',
    createdtime: 'Creation time',
    loopid: 'Channel ID',
    loopname: 'Channel',
    devicetypeid: 'SKU',
    more: 'More',
    collapse: 'Less',
    deviceoperating: 'Task',
    move: 'Move',
    replace: 'Replace',
    delete: 'Delete',
    factorysetting: 'Reset',
    restart: 'Restart',
    stop: 'Stop',
    start: 'Start',
    parameter: 'Device parameters',
    ota: 'Firmware',
    currentversion: 'Current version',
    newversion: 'Cloud version',
    uptodate: 'NEW',
    advancedoptions: 'Advanced options',
    specificversion: 'Special version',
    upgrade: 'Upgrade',
    pause: 'Pause',
    issued: 'Download the file',
    initiatefail: 'Upgrade failed',
    ingfail: 'Upgrade failed',
    stopfail: 'Stop failed',
    stopsuccess: 'Stop sussessed',
    prompt: 'Info',
    deletedeviceinfor: 'Are you sure to delete?',
    resetdeviceinfor: 'Are you sure to reset?',
    restartdeviceinfor: 'Are you sure to restart?',
    replacedeviceinfor: 'Are you sure to replace?',
    calibratedeviceinfor: 'Are you sure to calibrate?',
    save: 'Sure',
    cancle: 'Cancel',
    configsuccess: 'Success',
    configing: 'Configuring',
    configfail: 'Fail',
    configdefault: 'Default',
    hightOption: 'Advanced options',
    specificVersion: 'Special version',
    uppage: 'Go up',
    downpage: 'Go down',
    savesubmit: 'Save',
    uplevel: 'Upgrade',
    waitForupgrade: 'Waiting for upgrade',
    Upgradeing: 'Upgrading',
    UpgradeSuccess: 'Succeeded',
    UpgradeDuplicate: 'Duplicated',
    UpgradeFail: 'Failed',
    UpgradeConfilct: 'Conflict occured!',
    UpgradeBusy: 'Busy',
    UpgradeProjectIdNull: 'Please fill in the project ID',
    parentdevicename: 'Parent Device',
    calibrate: 'Calibrate',
    calibrateLUX: 'Calibrated Lux',
    calibrateLUXButton: 'Set',
    calibrateLUXTip: 'Calibrate',
    calibrateTemp: 'Calibrate Temp',
    calibrateTempButton: 'Set',
    calibrateTempTip: 'Calibrate',
    sure: 'Sure',
    calibrateBoxTip: 'The current desktop illumination value',
    calibrateHistoryTip: 'Recorded lux level',
    calibrateAddItem: 'Add',
    calibrateItemRealityTip: 'Current sensor value',
    calibrateItemInputTip: 'Current lux meter value',
    calibrateItemWriteTip: 'Please fill in the lux meter value',
    calibrateItemLimitTip: 'Please add no more than # records. ',
    otaupdateBleTip: 'The devices of the same type will be upgraded all at once. This may take more than 30 mins per type.',
    isActionPostTitle: 'Live scene preview',
    calibrateTempBoxTip: 'The current desktop temperature value',
    calibrateTempHistoryTip: 'Recorded temperature level',
    calibrateTempItemRealityTip: 'Current actual temperature value',
    calibrateTempItemInputTip: 'Current measured temperature',
    calibrateTempItemWriteTip: 'Enter measured temperature value',
    gateWayBoard: 'Board',
    gateWaySubCard: 'Card',
    morefirmwaretip: 'The following firmware belongs to the device and can only be upgraded step by step.',
    morefirmwareview: 'View the latest firmware status',
    canUpgradeingMaster: 'Upgradable',
    firmwareNo: 'Serial',
    otabootTrue: 'The above operations have been confirmed',
    lengthLimit: 'Please enter 1-{{length}} characters',
    heating: 'Heating',
    refrigeration: 'Cooling',
    dehumidification: 'Dehumidification',
    airSupply: 'Air supply',
    soundOff: 'Silent',
    LSpeed: 'Low speed',
    MSpeed: 'Medium speed',
    HSpeed: 'High speed',
    auto: 'Automatic',
    groupPlaceholder: 'Please  enter the neighbour group number from 0-250',
    group: 'Group',
    area2: 'area',
    groupTips: 'Add up to 8 neighbor groups',
    colorCustomize: 'Custom',
    cxCyEmpty: 'Please enter Cx and Cy coordinates in the format 0.0000, 0.0000',
    cxCyFormatError: 'Please enter a valid coordinate format, e.g. 0.4527, 0.3937',
    cxCyOutOfRange: 'The color coordinates are out of the valid range. Please re-enter',
    validHexColor: 'Please enter a valid hexadecimal color value',
    rangeOfTheColorPalette: 'The input color value exceeds the range of the color palette and has been corrected to the color palette',
    know: 'Got it！',
    ciexy: 'CIExy',
    noRelationDevice: 'No associated devices at the moment',
    refreshing: 'Refreshing...',
    refreshFail: 'Refresh failed. Please try again',
    refreshSuccess: 'Refresh successful',
    pleaseSetWifi: 'Please set up Wi-Fi in the parameter configuration first!',
    lengthLimit1: 'Please limit the text length',
    lengthLimit2: 'Please limit the password length',
    screenSetting: 'Screen Setting',
    defaultScreen: 'Default screen',
    maxScreenSettingTips: 'Support up to {{MaxCount}} ',
    keySetting: 'Button setup',
    keyInput: 'Please enter the button title',
    unSetting: 'Not set',
    secondDeleteConfirm: 'The scenes and automation related to #name# and its sub-devices will become invalid. Are you sure you want to delete it?',
    option1: 'Option 1',
    option2: 'Option 2',
    changeBind: 'Change bind',
    sureOk: 'Confirmation of the above process completion',
    replaceMain: 'Replace Master Unit',
    replaceSlave: 'Replace Slave Unit.',
    goodness: 'Goodness of fit',
    excellent: 'Excellent',
    makeDo: 'Average',
    poor: 'Poor',
    tropic: 'Best-fit line',
    rawData: 'Raw data',
    noOtaDevice: 'No upgradable devices in this area',
    recommendedValue: 'Recommended value',
    pleaseSelectDataType: 'Please select data type:',
    lightAndPpfd: 'Light and Photosynthetic Photon Flux Density (PPFD)',
    channelCountChanged: 'Channel count changed, please check controller No. {errorIndex}'
  },
  colorPicker: {
    gradient: 'Gradient color selection',
    gradientNum: 'Select at least {{min}} colors.',
    gradientNum2: 'No more than {{max}}'
  },
  deviceChoose: {
    choose: 'Select device(s)',
    group: 'Save group',
    save: 'Save',
    groupwarning: 'Fill in a group name',
    sure: 'Confirm',
    groupsingle: 'Group',
    checkwarning: 'Please select at least one device',
    checkgroupwarning: 'Please check the square box first',
    devicestotal: 'Device(s)',
    overStepDeviceGroupTip: 'The rendered devices are not in the same area, and this group will be saved to the specified area',
    chooseDeviceInMap: 'Use floorplan selection'
  },
  addScenes: {
    work: 'Work',
    offwork: 'Offwork',
    rest: 'Rest',
    sweep: 'Sweep',
    emergency: 'Emergency',
    none: 'None',
    scenenamewarning: 'Please give the scene a name',
    actionwarning: 'Please select the device',
    select: 'Select',
    isLightActionAutoOpareTip: 'In case you want the luminaire to turn ON when this scene is activated, make sure the Switch-function is enabled, and the switch set to On.'
  },
  ifttt: {
    searchPlhode1: 'Automation name/keyword',
    iftttSetTemplate: 'Important! When using a sensor automation and daylight control at the same time, you can only use the ON*-OFF (no brightness) template!',
    constillumsetTips: 'Devices that have participated in automatic brightness adjustment cannot participate in constant illumination automation at the same time.',
    constillumset: 'Daylight Control',
    aleadyset: 'Configured',
    rhythmset: 'Schedule Control',
    customize: 'Custom Automation',
    template: 'Office template',
    clouddo: 'Cloud',
    proximaldo: 'Smart Connect Box',
    success: 'Success',
    fail: 'Fail',
    ing: 'Setting',
    custommode: 'Custom',
    illuminationmodel: 'Daylight',
    rhythmode: 'Schedule',
    manual: 'Manual',
    status: 'Status',
    time: 'Time',
    delcounterror: 'Select one',
    light: 'Daylight control',
    allset: 'Configured',
    rhythm: 'Schedule',
    templateName: 'Template',
    template2: 'Other template',
    handle: 'Manual',
    templateName2: 'Template',
    rhythm00: 'Select Smart Connect Box',
    rhythm01: 'Select device(s)',
    lightTripOption: 'Setting the parameters of the light strip',
    lightTripSelect: 'Select the light strip to be adjusted',
    lightTripLampCount: 'Please input the number of LED count of single light strip',
    lightTripDirection: 'Please select the alignment type of the light strip',
    lightTripTransverse: 'horizontal',
    lightTripVertical: 'vertical',
    rhythm02: 'Schedule control',
    rhythmLine: 'Schedule curve',
    set: 'Set',
    lightDevice: 'Luminaires',
    window: 'Curtain',
    lightName: 'Brightness',
    colorName: 'CCT',
    addTime: 'Add',
    openDegree: 'OpenDegree',
    Degree: 'Degree',
    info: 'OpenDegree：the ratio of the leaf to the overall area of the shutter; Degree：The angle at which the fan leaves of shutters open。',
    save: 'Save',
    upStep: 'Back',
    yes: 'Confirm',
    sun: 'Level',
    light00: 'Select Smart Connect Box',
    light01: 'Select the daylight sensor',
    light02: 'Select the daylight controlled luminaires',
    light03: 'Requirements',
    light04: 'Calibration',
    requirement: 'Requirements',
    requirement01: 'Calibrate the illuminance value of the sensor;',
    requirement02: 'Ensure that the impact of sunlight on the sensor does not exceed 70% during installation;',
    requirement03: 'Ensure that the reading of the sensor and the luxmeter is not disturbed at the time of installation;',
    requirement04: 'Please input the illuminance value after calibration of reference point.',
    farmingRequirement01: 'Keep the photosensitive surface facing horizontally upward, away from columns, sprinklers, luminaires, and other obstructed or splashing areas;',
    farmingRequirement02: 'Mount with a rigid bracket; separate signal cables from power cables and waterproof all connectors;',
    farmingRequirement03: 'Place measurement points in the center of the planting area; deploy multiple points by zone in large areas;',
    farmingRequirement04: 'Clean the sensor dome regularly to prevent fouling from affecting measurement accuracy.',
    nextStep: 'Next',
    luxNum: 'Sensor：',
    watch01: 'Check your luxmeter',
    watch02: 'Set the luminaire dim',
    address: 'Area',
    standard: 'Illuminance Standard Value (Lux).',
    timeSet: 'Adjust the properties of the device in different time periods',
    timeAdd: 'To',
    timeStart: 'Start',
    timeEnd: 'End',
    timePlaceholder: 'Time interval',
    templateState: 'Status',
    execute: 'Cloud',
    baseMsg: 'Info',
    tempateName: 'Name：',
    iftttSet: 'Automation',
    rangTime: 'Effective time',
    day: 'Working days/all time',
    add: 'Add',
    if: 'If',
    iftttPlaceholder: 'Select',
    timing: 'Timing',
    stating: 'Do',
    delayed: 'Delay',
    minute: 'Min',
    statingGo: 'Do',
    back: 'Back',
    week: 'Week',
    weekpush: 'Holidays excluded',
    cancel: 'Cancel',
    timingset: 'Time',
    templateManger: 'Template Management',
    templatetext: 'Template',
    templateinfo: 'Add',
    addTemplate: 'Add',
    closeRhythm: 'Disable schedule ',
    addPanel: 'Add switch',
    PanelInfo: 'Press the key of the switch',
    dayPlaceholder: 'Select data',
    'trigger ': 'Trigger',
    introduce: 'Introduce',
    scence: 'Scence',
    closeLight: 'Turn off all luminaires',
    trigger: 'Trigger',
    open: 'ON',
    close: 'OFF',
    addressText1: 'Living room (general activities)',
    addressText2: 'Living room (writing and reading)',
    addressText3: 'Dining room',
    addressText4: 'Reading room ',
    addressText5: 'General Office',
    addressText6: 'Supermarket hall',
    addressText7: 'Hospital waiting room',
    addressText8: 'School classrooms',
    addressText9: 'Blackboard in school ',
    addressText10: 'Corridor',
    addressText11: 'Machining',
    Illuminance: 'Lux',
    color: 'Color',
    zdy: 'Please go to the settings ',
    zdylight: 'Please go to the settings ',
    hourxh: 'Default mode (24h)',
    secondsxh: 'Show mode (24s)',
    warning1: 'Select one device',
    warning2: 'Please select an excution time',
    warning3: 'Time conflicts, Please select an excution time',
    warning4: 'Choose a time period to avoid conflict',
    no: 'NO',
    iftttSelect: 'Select Automation (ifttt)',
    selectIFTTT: 'Please select at least one Automation (ifttt)',
    openSwitch: 'ON',
    closeSwitch: 'OFF',
    del: 'Delete',
    selected: 'Selected',
    farGoing: 'Processed via cloud',
    nearGoing: 'Processed via Smart Connect Box',
    timingDot: 'Timer：',
    sensorDot: 'Sensor：',
    rhythmtime: 'Time',
    nowarn: 'Sorry, you cannot change the loop staus in this step',
    groupControl: 'Group',
    timeStarToEnd: 'Selected time period (end time is greater than or equal to start time)',
    selectGateway: 'Please select the Smart Connect Box',
    groupControlTip: 'After group control is selected, all current devices and groups are not available!',
    noFindGateWayTip: 'No Smart Connect Box avaliable',
    luxCorrectNum: 'Calibrated lux level：',
    constillumName: 'Daylight automation name',
    rhythmName: 'Schedule name',
    constillumNameTips: 'Please define a name of the daylight automation here',
    rhythmNameTips: 'Please enter a schedule name',
    rhythmSelectJoinModel: 'Enable',
    manualmode: 'Manual',
    panelmode: 'Smart Switch',
    devicemode: 'Smart Sensor',
    schedulemode: 'Timing',
    nonemode: 'None',
    sensorCorrectionTips: 'Note: The sensor has not been calibrated. Please calibarte the sensor first in the installation page. ',
    automationTotal: 'Automation Total',
    iftttCustomSetPanel: 'Smart Switch',
    iftttSelectPanel: 'Select Smart Switch',
    iftttDefaultNoRealImg: 'Picture not avaliable yet ',
    automationRules: 'Automation Rules',
    configurationDetails: 'Configuration Details',
    maxConfigMessage: 'Maximum 10 time points ',
    maxConfigMessage30: 'Maximum 30 time points ',
    configWarnMessage: 'The distance between two points should be more than 1 hour.',
    hclConfig: 'HCL',
    lightTripConfig: 'Strip configuration',
    templateConfig: 'Quick Automation',
    hcl: 'HCL',
    areacontrol: 'Area Control',
    hclNameTips: 'Please enter a HCL name',
    hclName: 'HCL name',
    hcl02: 'Set HCL curve',
    hclLine: 'HCL curve view',
    copyIfttt: 'Copy IFTTT',
    isLoadingData: 'Data loading Please wait a moment',
    notice: 'Notification',
    needOneClickConfiguration: 'Whether one-click configuration is required',
    oneClickConfiguration: 'One Click Configuration',
    elfInfo: 'One-click configuration will automatically configure the automation for the "On/Off", "Brightness", "Color Temperature/Color" buttons, Scenes need to be configured on the device detail page.',
    controlObject: 'Control devices',
    wakePro: 'Please wake up the device by clicking any key on the device, and click "Save".',
    wakeProRetry: 'Please wake up the device by clicking any key on the device.',
    aWakened: 'Wake up',
    associatedConfiguration: 'Bundle Configurations',
    associatedInfo: 'Please add the devices',
    associatedConditioning: 'Bundle air conditioner',
    addObject: 'Add devices',
    noConfiguration: 'No configuration',
    buttonAutomation: 'Automation configuration of keys',
    createUp3: 'Create up to ${{n}} items',
    selectObjects: 'Select devices',
    intelligentControl: 'Senes (optional)',
    clickExecute: 'Short press to execute',
    lightDetection: 'Light Detection',
    clickDetect: 'Click to detect',
    switchFn1: 'Click to switch function',
    switchFn2: 'Rotate to adjust the value',
    onOff: 'Short press to turn on/off light',
    rotate: 'Rotate',
    constantIlluminanceTip: 'When the constant illumination strategy adjusts the brightness of the lamp to the lowest level, turn off the lights',
    chooseSame: 'Please select similar devices',
    sureUseIfttt: 'Are you sure to enable automation',
    sureDisableIfttt: 'Are you sure to disable automation',
    useIftttTip: `After enabling automation, the current area's timing, schedule, rhythm, constant illumination, and automation will be activated`,
    disableIftttTip: `After disabling automation, the current area's timing, schedule, rhythm, constant illumination,
       and automation will be disabled`,
    needChangeGateway: `Sorry! This smart connect box doesn't support 'Toggle Off/On' function,
    if you want to use this function then please change to the compatible connect box.`,
    needUpdateGateway: 'Please upgrade the firmware first, then you can use the “Toggle Off/On” function.',
    sensorTemplate: 'Sensor Template',
    panelTemplate: 'Panel Template',
    scheduledSequence: 'Scheduled Sequence',
    loopSequence: 'Loop Sequence',
    actionItem: 'Action Item',
    pleaseAddOneActionItem: 'Please add at least one action item',
    addScheduledSequenceItem: 'Add Scheduled Sequence Item',
    sunriseSunset: 'Sunrise/Sunset',
    pleaseAddOneSequenceStep: 'Please add at least one scheduled sequence step',
    eachStepNeedsActionItem: 'Each scheduled sequence step must contain at least one action item',
    absoluteTime: 'Absolute Time',
    relativeDelay: 'Relative Delay',
    effectiveCount: 'Effective Count',
    repeatLoop: 'Repeat Loop',
    customLoopCount: 'Custom Loop Count',
    times: 'Times',
    supportSunriseSunsetOffset: 'Supports setting 0–240 minutes before/after sunrise/sunset',
    selectSunriseSunset: 'Select Sunrise/Sunset',
    associatedDateSettings: 'Associated Date Settings',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    supplementalLighting: 'Supplemental Lighting',
    slTimeOverlapTip: 'Time ranges cannot overlap; natural light unit: μmol/(m²·s)',
    slAddStrategy: '+ New Strategy',
    slEmptyStrategy: 'No strategies yet. Click "New Strategy" to start',
    slStrategyName: 'Strategy Name',
    slStrategyType: 'Strategy Type',
    slLampSwitchStatus: 'Lamp Status',
    slTargetBrightnessPpfd: 'Target Brightness | PPFD',
    slTargetLightPpfd: 'Target Light (PPFD)',
    slIsEnabled: 'Enabled',
    slNewStrategy: 'New Strategy',
    slEditStrategy: 'Edit Strategy',
    slStrategyNameLabel: 'Strategy Name:',
    slStrategyCondition: 'Strategy Conditions',
    slExecuteAction: 'Execution Actions',
    slNaturalLightMin: 'Natural Light Min:',
    slNaturalLightMax: 'Natural Light Max:',
    slNaturalLightRangeError: 'Natural light min must be less than natural light max',
    slDelayLightOn: 'Delayed Light On',
    slDelayLightOnTip: 'After the light turns on, brightness gradually increases from 0% to the target brightness. The system steps through multi-stage dimming based on the adjustment interval and total adjustment count until the target is reached.',
    slAdjustInterval: 'Adjust Interval:',
    slAdjustCount: 'Adjust Count:',
    slTargetBrightness: 'Target Brightness:',
    slTargetLight: 'Target Light:',
    slTimeOrderError: 'Start time and end time cannot be the same',
    slTimeOverlapError: 'Time ranges overlap. Please adjust before saving',
    slDelayAdjustDurationError: 'Adjust interval × (adjust count - 1) cannot exceed the strategy duration',
    slCrossDay: ' (cross-day)',
    slApplying: 'Applying strategy…',
    slCreating: 'Creating…',
    slSaving: 'Saving…',
    slStrategyPrefix: 'Strategy',
    slTypeStaticTimed: 'Static (Timed)',
    slTypeStaticNatural: 'Static (Timed + Natural Light)',
    slTypeDynamic: 'Dynamic',
    slAreaAnchor: 'Area Anchor (μmol/m²·s)',
    slAreaAnchorTip: 'Full-on light intensity anchor used to convert brightness % to PPFD: PPFD = area anchor × brightness %',
    slArtificialDli: 'Artificial DLI (mol/m²·d):',
    slNaturalDli: 'Natural DLI (mol/m²·d):',
    slCumulativeDli: 'Cumulative DLI (mol/m²·d):',
    slTurnOffWhenMet: 'Turn off when condition is met',
    slTimelineCover: '24H Coverage',
    slSelectAreaLeft: 'Please select an area on the left first',
    slCompleteStrategy: 'Please complete the strategy information',
    slConfirmDelete: 'Delete this strategy?',
    slDisabled: 'Disabled',
  },
  iftttset: {
    noSimultaneously: 'Cannot be executed simultaneously',
    rename: 'Rename',
    isOccupied: 'The following devices have been set to $$, Unable to use Group Control',
    or: 'or',
    Mon: 'Mon',
    Tues: 'Tue',
    Wed: 'Wed',
    Thur: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
    doifttt: 'Do a ifttt',
    doswitchifttt: 'ON/OFF ifttt',
    doscene: 'Scene',
    device: 'Device',
    allcondition: 'All condition',
    onecondition: 'Any condition',
    select: 'Select',
    allday: 'Day',
    long: 'Always',
    noholiday: 'Addition to the holidays',
    baseinfor: 'Info',
    basename: 'Name',
    automationset: 'Automation',
    effectivetime: 'When',
    adddata: 'Add',
    if: 'If',
    selectioncriteria: 'Select',
    timing: 'Timing',
    handledo: 'Manual',
    do: 'Do',
    do1: 'Do',
    delay: 'Delay',
    minutes: 'Min',
    scene: 'Scene',
    ifttt: 'Automation',
    switchifttt: 'ON/OFF ifttt',
    save: 'Save',
    back: 'Back',
    week: 'Week',
    time: 'Time',
    to: 'To',
    starttime: 'Start',
    endtime: 'End',
    range: 'Time interval',
    data: 'data',
    butholiday: 'Addition to the holidays',
    sure: 'Yes',
    cancle: 'Cancel',
    timingset: 'Timing',
    delayset: 'Delay',
    triggerset: 'Trigger',
    actionset: 'Action',
    namewarning: 'Please create a name for the ifttt',
    effectivetimewarning: 'Set the activation time',
    conditions: 'Select the condition',
    triggerwarning: 'Please define your if condition first.',
    actionwarning: 'Please define your Do condition first.',
    weekwarning: 'Select one data',
    handlewarning: 'Manual ifttt cannot be deleted',
    nodoiftttwarning: 'Execute ifttt wrong',
    onehandlewarning: 'Only one manual ifttt can be added',
    deldevicewarning: 'Delete the device and time first',
    candohandlewarning: 'Manual ifttt cannnot be excuted',
    delhandlewarning: 'Please delete the manual ifttt first',
    tommrow: 'tomorrow',
    upmove: 'Move up',
    downmove: 'Move down',
    up: 'Go up',
    down: 'Go down',
    and: 'till',
    hour: 'Hour',
    off: 'OFF mode',
    on: 'ON mode',
    add: 'Automation',
    minus: '- mode',
    colormode: 'Warm Mode',
    colorAddmode: 'Warm Mode',
    colorMinusmode: 'Cold Mode',
    closeMode: 'Close all the other mode',
    openMode: 'Open all the other mode',
    key1: 'Key1',
    key2: 'Key2',
    key3: 'Key3',
    key4: 'Key4',
    key5: 'Key5',
    key6: 'Key6',
    key7: 'Key7',
    key8: 'Key8',
    keyOn: 'KeyON',
    keyOff: 'KeyOFF',
    keyAdd: 'Key+',
    keyMinus: 'Key-',
    officeMode: 'Meetting mode 1',
    speechMode1: 'PPT mode 1',
    speechMode2: 'PPT mode2',
    officeTemplate: 'Office mode',
    chooseTemplate: 'Please select the template',
    choose: 'Choose',
    enterTemplateName: 'Please fill in the template name',
    havePeople: 'Occupied',
    noPeople: 'Empty',
    illumination: 'Daylight control',
    rhythm: 'Schedule',
    second: 'second',
    officeAutomation: 'Office automation set',
    SelectDelayTime: 'Please choose the delay time',
    SelecTtriggle: 'At least one events need to be defined',
    SelecAction: 'At least one action need to be defined',
    SelecTime: 'Select the time',
    haveTime: 'Time already exist',
    setTiming: 'You could only set one time',
    setSun: 'You could only set one sunrise/sunset',
    timeOrSunExclusive: 'Timing and sunrise/sunset can only exist one of them',
    pleaseAddOneDelayItem: 'Please add at least one delay item',
    lux: 'Lux',
    times: 's',
    dataStep: 'Synchronising',
    ok: 'Sure',
    cancel: 'Cancel',
    info: 'Info',
    delIllumination: 'Are you sure to delete the daylight scene?',
    delRhythm: 'Confirm to delete the schedule?',
    IlluminationDevice: 'Luminaires',
    developAutomation: 'Advanced automation',
    deviceMove: 'Motion sensor',
    deviceMove1: 'Motion sensor',
    alreadydelete: 'it has already been deleted',
    alreadymove: 'it has already been moved',
    repeat: 'Repeat',
    every: 'Everyday',
    wordDay: 'Workday（Mon-Fri）',
    weekEnd: 'Weekend',
    customize: 'Custom',
    weekTip: 'please select repeat period',
    timeTip: 'please select the start and end time',
    dataTip: 'please select start and end date',
    along: 'Along',
    triggershowtotaltip: 'Please add no more than #16# If conditions',
    actionshowtotaltip: 'Please add no more than #32# Do conditions',
    triggerandactiontip: 'Please add no more than #16# If conditions and #32# Do conditions.',
    areacontrol: 'Area Control',
    SelecArea: 'At least one area need to be defined',
    hcl: 'HCL',
    templateList: 'Automation template list',
    holidays: 'Holidays (Incl.Weekend)',
    notHolidays: 'Non-holidays',
    executeOnlyOnce: 'Execute Once Only',
    executionMode: 'Execution Mode',
    moreSettings: 'More Settings',
    local: 'Local',
    cloud: 'Cloud',
    recommendation: 'Recommendation',
    tip1: 'Local execution is available even in offline mode',
    tip2: 'If local execution is not possible, try switching to cloud execution',
    ifttt3Tip: 'The following devices do not support the #holiday# feature. Please make adjustments',
    ifttt3Tip2: 'The following devices support the #holiday# feature after the upgrade.',
    delayedToggleAutomationSwitchState: 'Delay the automation switch state flip',
    automaticalTurnOnOff: '#2 seconds# later, automatically #turn off#',
    automationSettings: 'Automation Settings',
    toggleSettings: 'On/Off Toggle Settings',
    notConfigured: 'Holiday settings are not configured. Please go to the project details to configure the holidays first',
    permissionDenied: 'It has been detected that you do not have the required permission for this action. Please contact the project manager/installer to request access.',
    areaName: 'Room Name',
    gotoConfig: "Go to configure",
    sunrise: 'Sunrise',
    sunset: 'Sunset',
    dateRange: 'Date range',
    timingSequenceAction: 'Timing sequence action',
    timeSetting: 'Time setting',
    pleaseInputConstantLightIntensityName: 'Please enter the name of the constant light intensity',
    noSupportTip: 'Gateway or device version too low, please upgrade first',
  },
  lastLight: {
    Illuminance: 'Lux ',
    open: 'Open loop',
    close: 'Close loop',
    lessthan: 'Less than',
    brightness: 'brightness',
    range: 'Range',
    to: 'to',
    big: 'More than',
    standard: 'Standard',
    warning: 'Warning: Please wait until the sensor reading is stable',
    selectwaring: 'Select at least one device',
    must: 'Select at least one device',
    selectwaring2: 'Select the device',
    selectwaring3: 'Please fill in the lux level',
    selectwaring4: 'Wrong range',
    selectwaring5: 'Wrong range',
    selectwaring6: 'Wrong range'
  },
  otatask: {
    firmware: 'Firmware',
    mainFirmware: 'Main Firmware',
    childFirmware: 'childFirmware',
    latest: 'Latest',
    upgrading: 'Upgrading',
    taskCreateAllName: 'All Device Upgrade',
    areaname: 'Area',
    canUpgradeingDevice: 'Upgradable devices',
    canUpgradeingDevice2: 'Number of devices available for upgrading task',
    initiatefail: 'Fail',
    warninginfor: 'None',
    waitForupgrade: 'Waiting',
    UpgradeChecking: 'Checking',
    Upgradeing: 'Upgrading',
    UpgradeSuccess: 'Succeeded',
    taskSuccess: 'Succeeded',
    UpgradePartSuccess: 'Partially Succeeded',
    UpgradeDuplicate: 'Duplicated',
    UpgradeFail: 'Failed',
    taskFail: 'Failed',
    UpgradeConfilct: 'Conflict',
    UpgradeBusy: 'Busy',
    UpgradeProjectIdNull: 'No project ID',
    UpgradePasue: 'Pasue',
    info: 'Info',
    stopfail: 'Fail',
    stopsuccess: 'Success',
    createTime: 'CreateTime',
    startTime: 'StartTime',
    lastTime: 'LastTime',
    userId: 'User',
    bysku: 'By Type',
    byarea: 'By Area',
    devicetype: 'Type',
    selectedsku: 'Selected Sku',
    selecteddevice: 'Selected Device',
    resumeOperate: 'Resume Operate',
    taskname: 'Task Name',
    taskjuststart: 'Immediate execution',
    taskCustom: 'Scheduled execution',
    createUpgradeTask: 'Create Upgrade Task',
    createUpgradeTaskTimeTip: 'This upgrade task will take about # minutes. The results can be viewed in the upgrade task list',
    taskNameTip: 'Please enter task name',
    finishcontinuecreate: 'Create another task',
    taskDeleteTip: 'Are you sure you want to delete # task?',
    Unicast: 'Unicast',
    byprojectUpgradeStart: 'Upgrade All',
    selected: 'Selected',
    tasktitlesku: 'Types',
    tasktitledevice: 'Devices',
    UpgradeStop: 'Stopped',
    taskStop: 'Stop',
    nostopupdatetip: 'The selected equipment to be upgraded contains devices that cannot be terminated from the start of upgrade. After the upgrade task is cancelled, such devices will continue to complete the upgrade!',
    oparenosametip: 'The current selected task status is inconsistent, unable to unify batch operation',
    taskStoppingTip: 'Stop Doing',
    taskid: 'Task ID'
  },
  qrcode: {
    projectsettitle: 'Project location not determined!',
    projectsettip: 'QR code creation requires a clear location of the project to set the fence permissions',
    projectsetok: 'Set it up',
    projectsetcancel: 'Not set',
    switchtitle: 'Are you sure to turn off QR code access?',
    switchtip: 'After the access right of QR code is closed, users who share through this QR code will no longer be able to access this area of this project, and users who are accessing will also be forced to exit!',
    deltitle: 'Are you sure to delete the QR code?',
    deltip: 'After the QR code is deleted, the regional access rights will be closed, the users who are accessing will be forced to exit, and all relevant information will be deleted!',
    qrcodetitle: 'Area Limit',
    switch: 'Share switch',
    sharearea: 'Share area',
    qrcodename: 'Name',
    qrcodenametip: 'Name cannot be empty',
    screenroatetip: 'For a better experience, please put the phone / tablet upright',
    intoloading: 'Loading QR code control center',
    device: 'Device',
    areacontrol: 'Area',
    scene: 'Scene',
    positionsearchtip: 'Please enter address',
    position: 'Position',
    latlon: 'lat-lon',
    latitude: 'Latitude',
    longitude: 'Longitude',
    ableActionTip: 'The sharer has turned off the access right. If you have any questions, please contact the administrator!',
    ableTokenTip: 'The permission is invalid. If you have any problem, please contact the administrator!',
    gpsOpen: 'Positioning is open',
    gpsOpenTip: 'To get your location information, please open location and allow browser to use location information<br><br>\n        Try the following:<br>\n        1. Please turn on the mobile location service and allow the browser to use the location information<br>\n        2. In browser location settings, all websites are allowed to access location information',
    locationserices: 'Location Services',
    whileappuse: 'While Using the App',
    beyondPositionTip: 'Try the following near the scan area:<br>\n        1. Please turn on the mobile location service and allow the browser to use the location information<br>\n        2. In the browser location settings, all websites are allowed to access location information',
    changearea: 'Change area',
    mapnoadresstip: 'Related address not found！',
    createqrcode: 'Create QrCode',
    createqrcodetips: 'You are about to create a QR-code that can be used to control the Smart Lighting installation via a smartphone. Please note that for safety reasons it is only possible to control the lighting via this QR code if the user is within 2km of the project location. As a result the user needs to have his GPS location turned on, and has to allow the webpage to use is, to be able to verify that the user is located at the project.',
    isWXAppTips: 'Please open it in the default browser',
    pulldownrefresh: 'refresh',
    releaseupdate: 'Release to refresh',
    updating: 'updating',
    loading: 'loading',
    startingGPSpositioning: 'Starting GPS positioning...',
    GPSPositioningInProgress: 'GPS positioning in progress...',
    accuracy: 'Accuracy',
    altitude: 'Altitude',
    altitudeAccuracy: 'Altitude Accuracy',
    heading: 'Heading',
    groundSpeed: 'Ground Speed',
    GPSPositioningFailed: 'GPS positioning failed',
    startingBDPositioning: 'Starting BD positioning...',
    BDPositioningInProgress: 'BD positioning in progress...',
    BDPositioningDataReturned: 'BD positioning data returned...',
    BDPpositioning: 'BD positioning',
    BDPositioningFailed: 'BD positioning failed',
    BDPositioningStartupFailed: 'BD positioning startup failed'
  },
  home: {
    changeProfessional: 'Successfully switched professional version',
    changeNotProfessional: 'Successfully switched to normal version',
    zoomScaleTip: 'The browser is in the zoom mode, the layout may not fit the page. 100% scaling is recommended.',
    onlineTipsHeaderTitle: 'Offline?',
    onlineTipsDescribe: 'Please double check the internet connections. The settings will be stored in the cloud. An unstable internet connection may lead to data loss.',
    onlineTipsOKtext: 'Ok',
    allArea: 'All areas',
    allProject: 'All projects',
    ruiyi: 'Smart Lighting',
    ouxiangjia: 'Smart Home',
    collectTop: 'Top Collection Items',
    collectOnly: 'Only show my favourite'
  },
  base: {
    notice: 'Notice',
    sure: 'OK',
    back: 'Back',
    cancel: 'Cancel',
    deltext: 'Are you sure to delete?',
    more: 'More',
    delete: 'Delete',
    transfer: 'Transfer',
    move: 'Move',
    download: 'Download',
    export: 'Export',
    import: 'Import',
    type: 'Type',
    state: 'State',
    all: 'All',
    total: 'Total',
    upStep: 'Back',
    nextStep: 'Next',
    name: 'Name',
    selectall: 'All',
    latestedVersion: 'Latested Version',
    localVersion: 'Local Version',
    restart: 'Restart',
    start: 'Start',
    pasue: 'Pasue',
    refresh: 'Refresh',
    create: 'Create',
    searchKey: 'Search Key',
    searchByState: 'Search By State',
    searchByCreateTime: 'Search By CreateTime',
    operate: 'Operate',
    resetFilter: 'Reset Filter',
    to: 'To',
    startdate: 'Start time',
    enddate: 'End time',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    lastThreeMonths: 'Last Three Months',
    details: 'Details',
    startingTip: 'Start Doing',
    restartingTip: 'Restart Doing',
    errorcode: 'Error code',
    search: 'Search',
    succeed: 'Succeed',
    error: 'Error',
    group: 'Group',
    applyFor: 'Apply for',
    noEmpty: 'cannot be empty',
    bind: 'Bind',
    unbind: 'UnBind',
    redraw: 'Redraw the point',
    mobilephonenumber: 'Moblie Phone',
    smsverificatoncode: 'Verification Code',
    sendverificatoncode: 'Send',
    sendagain: 'Send',
    write: 'Write',
    finish: 'Finish',
    spread: 'Spread',
    modify: 'Modify',
    notip: 'No Tips',
    detail: 'Detail',
    save: 'Save',
    yes: 'yes',
    no: 'no',
    skip: 'Skip',
    updateTitle: 'Release Notes',
    helpCenter: 'Help Center',
    before: 'Before',
    after: 'After',
  },
  visual: {
    pdfTransFail: 'Failed to convert PDF file.',
    sizeMaxFile: `File dimensions must not exceed $$1px*$$2px`,
    maxFile: 'File size must not exceed $$mb',
    lightRate: 'Lighting rate',
    areaRank: 'Regional ranking',
    areaChoose: 'Select a area',
    searchDevicePlaceholder: 'Please enter a device name for searching',
    deviceDetail: 'Device details',
    childDeviceRelation: 'Devices topology',
    drawRoom: 'Drawing room',
    drawArea: 'Drawing area',
    pic: 'Pictures',
    maxNumPic: 'Upload up to 10 pictures',
    maxSizePic: 'Image size cannot be larger than 10000*10000px.',
    deviceNeedTime: 'Device is not fully loaded yet',
    lowEnergy: 'Low energy',
    highEnergy: 'High energy',
    upImgAndLook: 'There are no drawings under the area,Please follow the steps below to add drawings and related configurations before viewing them.',
    initConfigTip1: 'There are currently no drawings for this area. Please add drawings first by following the steps below.',
    initConfigTip2: '1. Supports .jpg, .jpeg, and .png image formats with a size not exceeding $$1MB and less than $$2px * $$3px.',
    initConfigTip3: `2. Supports .pdf format with no size limit.`,
    regionFrom: 'Area',
    isSetNetwork: 'Type',
    moreTitle: 'More status and equipment operation',
    deviceMore: 'Click to view',
    bindagin: 'Re-binding',
    bindingDiologTxt: 'Delete area frame only: ',
    bindingDiologTxt1: 'Delete the area frame only, device icons remain.',
    bindingDiologTxt2: 'Delete All: ',
    bindingDiologTxt3: 'Delete the area and device icons.',
    bindingDiologBtnTxt: 'Delete area frame only',
    bindingDiologBtnTxt1: 'Delete All',
    rightBind: 'Right-click to bound room',
    monitorUploadImg: 'There is no drawings in this area.',
    toUpload: 'Go to upload',
    currentArea: 'Current area',
    enableIfttt: 'Enable',
    disableIfttt: 'Disable',
    enableIftttDialogTitle: 'The following types of automation will be enabled, other automations are not affected!',
    disableIftttDialogTitle: 'The following types of automation will be disabled, other automations are not affected!',
    useDeviceDailog: 'Use device list to select',
    chooseDeviceInMap: 'Use floorplan selection',
    cancleAllSelect: 'Cancel all',
    selectSameDevice: 'Select the same type of devices',
    chooseSKU: 'Select product type',
    deleteConfirmTxt: "After deleting an area, the original devices' locations in the area will be automatically removed from the floorplan.",
    rebindConfirmTxt: "After re-allocating an area, the original devices' locations in the area will be automatically removed from the floorplan.",
    deviceTypes: 'Please select the device protocol type',
    deleteEquipmentTip1: 'Delete region only: Delete only the region box and keep the device icon <br /> Delete All: Deletes the region and the device icon within the region',
    deleteEquipmentTip2: 'Delete only the region box',
    deleteEquipmentTip3: 'Delete all',
    please: 'Please',
    deviceRepeat: 'Device already exists',
    deviceInSelectRoom: 'The device(s) needs to be placed in the selected room',
    device: 'Device',
    selectRoom: 'Please select the area: ##',
    deviceListMsg: 'After the marked area is linked, the device can be dragged to the marked area.',
    batchMobile: 'Move multiple devices',
    delAreaMsg: 'You need to remove all the devices in the marked area before rebinding. Are you sure to remove the devices?',
    modify: 'Edit',
    mapBg: 'Map background',
    roomTips: 'Room tag',
    deviceTips: 'Device tag',
    replace: 'Replace floor plan',
    del: 'Delete',
    identification: 'Identify',
    bindArea: 'Bound area',
    placeBind: 'Please bind the area with a room first',
    closeLight: 'OFF',
    uploadImg: 'Upload extra floor plan',
    imgSize: 'Picture size',
    lessThen: 'and less than',
    uploading: 'Uploading image, please wait',
    complete: 'Finish',
    bindAreaSet: 'Bound area settings',
    areaPlan: 'Area plan',
    areaIsBound: 'The room has been bound by other marked areas, please unbind it before operating!',
    areaDoNotBind: 'Area cannot be bound',
    clickInCanvas: 'Please try to tap and drag this device to the floor plan',
    imgType: 'Support jpg, jpeg, png format, the maximum size is 5MB',
    noImgType: 'This type of file is not supported',
    noImgSize: 'File too large',
    planarModel: 'Go to Floor plan',
    edtAreaMsg: 'There are still devices in the area. Please remove the devices before editing',
    mapIsLoading: 'Loading...',
    selectDevice: 'Select',
    scence: 'Scene',
    ifttt: 'Automation',
    ok: 'Confirm',
    cancel: 'Cancel',
    addScene: 'Scene',
    chooseDeviceGroup: 'Group',
    uifiedControl: 'Control All',
    width: 'width',
    height: 'height',
    editBg: 'Panel size',
    notice: 'Info',
    sureDelScene: 'Are you sure to delete?',
    sureDelGroup: 'Are you sure to delete?',
    delBg: 'Remove the background',
    noName: 'OPPLE',
    virtualDevice: 'Virtual Devices',
    virtualLibrary: 'Device List',
    areaname: 'Area',
    realDevice: 'Real Devices',
    floorname: 'Floor',
    virtualPoint: 'Virtual spot',
    rect: 'Rectangular area',
    pencil: 'Draw area',
    opacity: 'Transparency',
    bgColor: 'Black/white',
    virtualTips: 'Drag and drop device to the area',
    searchKey: 'Please enter device name',
    select: 'Select',
    zoomScale: 'Zoom scale',
    Legend: 'Filter',
    connectDevice: 'Connected devices',
    backDevice: 'Exist devices list',
    hasMac: 'Virtual devices with MAC',
    lightBox: 'Standard items - light box',
    batchBind: 'Batch Binding',
    batchNetwork: 'Batch network',
    oneKeyConfig: 'One-Click Dispatch',
    other: 'other',
    downloadPoint: 'Download Point List',
    createStandardProject: 'Create standard program',
    noNetwork: 'Undistributed network',
    toUpgrade: 'Go to upgrade',
    upgradeTip: 'If the following device versions do not meet the requirements, upgrade them before attempting to deliver them.',
    upgradeTip2: 'If there is no problem, click "Replace Device", fill in the MAC address again and deliver it again!',
    changeDevice: 'Replace device',
    sendScene: 'Scenario Dispatch',
    sendingScene: 'The scene is being delivered',
    sendSceneSuccess: 'The scene is delivered',
    sendSceneFail: 'The scene section fails',
    sendIfttt: 'Automated delivery',
    sendingIfttt: 'Automated delivery is in progress',
    sendIftttSuccess: 'Automation issued',
    sendIftttFail: 'Failure of the automation part',
    sendProgram: 'Issuance of the program booklet',
    sendingProgram: 'Programs are being distributed',
    sendProgramSuccess: 'The program list has been issued',
    sendProgramFail: 'The program list section failed',
    noBind: 'Unbound',
    macError: 'The MAC address is incorrect',
    uploadPoint: 'Upload the point table',
    pointName: 'Point name',
    remark: 'remark',
    next: 'Next',
    networked: 'reticulated',
    addressNotFilled: 'Address not filled in',
    addressRepeat: 'Duplicate address, please fill in again',
    waitNetwork: 'Wait for the device to connect to the network, please wait patiently, about 1-3 minutes...',
    continueNetwork: 'Continuous distribution network',
    waitNetwork2: 'Waiting for the device to enter the network',
    gatewayNetwork: 'The optical box gateway is being distributed',
    deviceRepeatBind: 'The device cannot be bound repeatedly',
    networkFail: 'Networking failed. Try again later.',
    gateway: 'Optical Box Gateway',
    networking: 'Configuring the network',
    networkFail2: 'Network distribution failed, please change MAC address and continue',
    networkFail3: 'The gateway version needs to be upgraded, please upgrade it first and then configure the network',
    networkFail4: 'Please click the "Operation" button of the device to count down',
    networkFail5: 'The gateway is added successfully, soft reboot in about 28 seconds, please later...',
    networkFail6: 'If there is no problem, please replace the device, fill in the MAC address again, and then click "Continue Network Configuration"',
    refreshDevice: 'Refresh the list of devices',
    pointNameTip: 'Specify the point name',
    networkState: 'Configuration status',
    bindDeviceTip: '{BindDeviceCount} devices have been bound, {NotBindPointCount} points have not been bound, and there are {NotBindDeviceCount} devices unbound, please bind the corresponding points and devices',
    networkFailTip: 'Failed to configure the network, try again later',
    goToMonitor: 'Go to Monitor',
    goToInstallation: 'Go to Installation',
    themeChange: 'theme Change',
    exit: 'Exit',
    duplicateMAC: 'There are duplicate devices at the same point',
    removeDevice: 'Please do not remove the device from the room.',
    moveIntoTheRoom: 'Move into the room',
    topLeft: 'Top Left',
    topRight: 'Top Right',
    Center: 'Center',
    bottomLeft: 'Bottom Left',
    bottomRight: 'Bottom Right',
    deviceClustering: 'Device Clustering'
  },
  sortSelect: {
    type1: 'Sort A-Z',
    type2: 'Sort Z-A',
    type3: 'Sort Newest First',
    type4: 'Sort Oldest First'
  },
  hcl: {
    deviceHcl: 'Rhythm of device',
    chartAllData: 'Show data',
    saveTemplate: 'Add to customized templates',
    oppleTemplate: 'OPPLE HCL Templates',
    template: 'Customized Templates',
    choose: 'Select ',
    hclType: 'Select HCL type',
    argumentType: 'Select parameter type',
    gradient: 'Smooth Mode',
    jump: 'Step Mode',
    lightCCT: 'Brightness+CCT',
    onlyLight: 'Brightness',
    onlyCCT: 'CCT',
    whichHcl: 'The device has been participated in {a}',
    CantHcl: 'The device does not support HCL',
    warning: 'Note: The current area contains devices that do not support HCL function, the area control function cannot be used ',
    warning1: 'Please upgrade the devices first',
    enable: 'Enable',
    unable: 'Disable ',
    state: 'Status',
    time: 'Time',
    number: 'No.',
    enabled: 'Enabled successfully ',
    unabled: 'Disabled ',
    perform: 'Smart connect box',
    useTemplate: 'Apply',
    office: 'Office',
    school: 'School',
    factory: 'Industry',
    naturalLight: 'Sunlight',
    keywords: 'Enter search keywords',
    addTime: 'Add time',
    allHcl: 'Brightness + CCT',
    lightHcl: 'Brightness',
    CCTHcl: 'CCT',
    hclState: 'Hcl status',
    tips: 'Notes',
    warning2: '1、When dragging to change the color temperature, the color temperature setting of the HCL automation to which the device belongs will be interrupted, and the brightness setting will continue. <br />2、When dragging to change the brightness, the brightness setting of the HCL automation to which the device belongs will be interrupted, and the color temperature setting will continue. <br />3、When both the brightness and color temperature have been changed, the HCL automation to which the devices belong will be disabled.<br />4、 If area HCL was created, the automation could not be interrupted.',
    HclConfig: 'HCL settings',
    warning3: 'Add point: Double-click anywhere on the HCL curve.',
    warning4: 'Edit point: Drag and drop the point.',
    warning5: 'Delete point: Click on the point and select delete.',
    warning6: 'Warning: The distance between two points should be more than 1 hour.',
    close: 'OFF',
    search: 'Search',
    introduce: 'Introduce',
    type: 'Type',
    del: 'Delete',
    all: 'All',
    cancle: 'Cancel',
    add: 'Add',
    set: 'List View',
    colorName: 'CCT',
    cardLightCCT: 'HCL Brightness + CCT',
    cardLight: 'HCL Brightness only',
    cardCCT: 'HCL CCT only',
    cardStop: 'HCL OFF',
    editPoint: 'Edit point',
    modify: 'Modify',
    clear: 'Clear',
    warning7: 'It is recommended to use area control settings for more than 20+ devices.',
    warning8: 'Please fill in the template name.'
  },
  identify: {
    identify_default: 'Use \\"identify\\" to localize device'
  },
  reset: {
    reset_00010900_step_1: '1、Power on the gateway\n2、Plug in the Ethernet cable: it must have access to the Internet and be able to obtain an IP address via DHCP.\n3、If required, connect DALI devices via DA+/DA−. No additional DALI bus power supply is needed.',
    reset_00010900_step_1_title: 'Wired Gateway Installation',
    reset_00010900_step_1_check: 'Powered on and connected to the network',
    reset_00010900_step_2: '1、Press and hold the "Operation" button on the front of the gateway for more than 10 seconds.\n2、As shown in the figure, the green status LED will flash rapidly, indicating that the gateway is entering reboot mode.',
    reset_00010900_step_2_title: 'The gateway has been reset.',
    reset_00010900_step_2_check: 'The gateway has been reset.',
    reset_00010900_step_3: '1、If the Ethernet indicator is off, please check if the connection between the Ethernet cable and the router is normal or if a static IP configuration is required. If using a static IP address, please follow the instructions to complete the setup.\n2、If the cloud indicator is off, please check if the router has internet access.\n3、If the status indicator is orange, it indicates a software malfunction. Please go back to the previous step and try again. If the issue persists, please contact the gateway provider.\n4、If the status indicator is red, it indicates a hardware malfunction. Please contact the gateway provider.',
    reset_00010900_step_3_title: 'Check Gateway Status',
    reset_00010900_step_3_check: 'All indicator lights are on and green',
    reset_00010900_step_4: 'Enter the MAC address from the gateway device, or scan the QR code on the device to generate the MAC address automatically',
    reset_00010900_step_4_title: 'Enter MAC Address',
    reset_00010900_step_5: 'Please press the "Confirm" button on the device, and then click the "Next" button on the page within 120 seconds after confirmation',
    reset_00010900_step_5_title: 'Confirm Gateway',
    reset_00010900_step_5_check: 'Device successfully recognized and confirmed'
  },
  energyBoard: {
    noMeasuringDevice: 'There is no metering device for this item, please add the metering device and then enter this configuration item.',
    energyFixedConfig: 'Energy consumption quota configuration',
    carbonEmission: 'Carbon Emission Factor Configuration',
    carbonFactor: 'Carbon emission factor',
    country: 'Country',
    inputByCountry: 'Current country has not configured the carbon emission factor, please input manually.',
    inputCarbonFactor: 'Input manually',
    inputManualSelection: 'Manual Selection',
    inputNumber: 'Please enter a number',
    configTips: 'Please make sure that all devices in the selected area are connected to the metering tool bound to that area.',
    energyAndcarbonEmissionsConfig: 'Energy Consumption Quota/Carbon Emission Configuration',
    measureDevice: 'Metering',
    deviceArea: 'Device Area',
    deviceStatistics: 'Device Statistical Area',
    timeClickTip: 'Click the date to select the start time, and click again to select the end time',
    HVAC: 'HVAC',
    powerConsumption: 'Power Consumption',
    otherConsumption: 'Other Consumption',
    showByDay: 'Daily',
    showByWeek: 'Weekly',
    showByMonth: 'Monthly',
    showByQuarter: 'Quarterly',
    showByYear: 'Yearly',
    countrySet: 'Project country',
    carbonEmissionSet: 'Allocate Carbon Emission Factor',
    YOYcurentMonth: 'Last Month',
    energyType: 'Comparison Types',
    addareaname: 'Add Area',
    editareaname: 'Switch Areas',
    energyCompare: 'Energy comparison',
    energyProportion: 'Energy Proportion',
    energyTime: 'Time Line',
    season: 'Quarter',
    energyConfig: 'Parameter Configuration',
    energyConfigTips: 'The statistics take effect when the current parameters are configured',
    statistiMonthly: 'Monthly',
    statistiQuarterly: 'Quarterly',
    statistiYear: 'Yearly',
    configTime: 'Configuration Time',
    configFinish: 'Succeed',
    carbonEmissions: 'Carbon Emissions',
    lightEnergy: 'Lighting Energy',
    maxEnergy: 'Max',
    minEnergy: 'Min',
    averageEnergy: 'Average',
    maxEnergySavingRate: 'Highest',
    minEnergySavingRate: 'Lowest',
    averageEnergySavingRate: 'Saving Rate',
    maxCarbonEmissions: 'Highest',
    minCarbonEmissions: 'Lowest',
    averageCarbonEmissions: 'Average',
    energy: 'Energy consumption',
    energyDesign: 'Expected',
    energyDesign1: 'Total Expected',
    energySave: 'Saved',
    energySaveToytal: 'Total Saved',
    actualEnergy: 'Actual',
    energyBalanceCounting: 'Energy consumption balance inverse',
    unit: 'Unit',
    energyUnit: 'Energy Consumption Units',
    carbonEmissionsUnit: 'Carbon Emission Units',
    currentMonth: 'This month',
    currentYear: 'This year',
    currentSeason: 'This quarter',
    energyRate: 'Energy percentage',
    energyComparison: 'Energy comparison',
    remainingEnergy: 'Energy Consumption Balance',
    energySavingRate: 'Energy Overview',
    remainingCarbonEmissions: 'Carbon Balance',
    carbonFootprint: 'Carbon Footprint',
    sequentialData: 'Monthly Comparison',
    year_to_yearData: 'YOY Data',
    graph: 'Graphs',
    table: 'Tables',
    exportTable: 'Export Reports',
    regionTips: 'Comparison of up to 3 areas',
    region: 'Select Area',
    statistiObject: 'Statistical Objects',
    statisticalIndex: 'Statistical Data',
    energyStatistics: 'Energy Statistics',
    quota: 'Fixed Amount',
    statistiArea: 'Statistical Area',
    energyQuota: 'Energy Consumption Quota',
    carbonEmissionsQuota: 'Emmission Allowance',
    carbonEmissionsAll: 'Cumulative Carbon Emissions',
    energyAll: 'Total',
    carbonBalanceCounting: 'Countdown of carbon emission balance',
    actualCarbonEmissions: 'Actual Carbon Emissions',
    year_to_year: 'Year-on-year',
    curentDay: 'Day',
    curentWeek: 'Week',
    curentMonth: 'This month',
    curentYear: ' This year',
    curentSeason: 'Season',
    YOYcurentDay: 'Last day',
    YOYcurentYear: 'Last year',
    YOYcurentSeason: 'Last quarter',
    staticSum: 'Statistical Overview',
    areaComparation: 'Historical Comparison',
    areaProportion: 'Area Comparison',
    max: 'Highest',
    min: 'Lowest',
    onlineTotal: 'Online / Total',
    openTotal: 'Lights On / Total',
    existSensor: 'Presence of illuminance sensors',
    config: 'Configuration',
    statistiObjectConfig: 'Metering Confirguration',
    other: 'Other',
    pieEnergyListHeader: 'Ranking of acual energy by area comparison',
    pieEnergyListDes: 'The bar chart shows the ranking of the actual energy consumption of the selected area in the selected timeframe.',
    pieEnergyHeader: 'Actual energy consumption by area',
    pieEnergyDes: 'The pie chart shows the actual energy consumption of the selected area in the selected time range.',
    statisticsNodule: 'Statistical Module',
    selectStatisticalArea: 'Please select a statistical area',
    selectStatisticalModule: 'Please select the statistics module',
    exportFailed: 'Export failure',
    sensorData: 'Sensor Data',
    prohibitCrossAreaSelection: 'Cross-region selection is prohibited',
    exportConfigTip1: 'Equipment overview and failure statistics can only export real-time data',
    exportConfigTip2: 'Sensor and space utilization can only derive data for the most recent year',
    exportConfigTip3: '(Total number of equipment, number of online, offline, fault and classification data)',
    exportConfigTip4: '(Movement, temperature, humidity, illumination)',
    exportConfigTip5: '(Index statistics, regional year-on-year/month-on-month ratio, regional proportion)',
    exportConfigTip6: 'The energy consumption proportion statistic defaults to the proportion of all subordinate regions.',
    selectDateRangeTip: 'The selected date range cannot exceed 5 years',
    selectDateRangeTip1: 'The selected date range cannot exceed 90 days',
    selectDateRangeTip2: 'The selected date range cannot exceed 12 months',
    problemFeedback: 'Report an issue',
    questionDescribe: 'Description',
    describeTip1: 'Please describe the issue you encountered or provide your advices in detail',
    describeTip2: 'Please enter the device SKU (8 bit Hex Chars), you can get it form Device info',
    describeTip3: 'Phone number or email',
    describeTip4: 'Please enter a valid phone number or email',
    describeTip5: 'Please fill in all the information',
    describeTip6: 'Upload a valid compressed file',
    describeTip7: 'Please enter MAC address of devices',
    describeTip8: 'Please enter your name',
    deviceInfo: 'Device Info',
    startTime: 'Issue Start and End Time',
    userInfo: 'User Info',
    userName: 'Name',
    userPhone: 'Contact Information',
    sureSubmit: 'Submit',
    firstEnergy: "Renovation Saving",
    secondEnergy: "Smart Saving",
    secondEnergyRate: "Smart Saving Rate",
    firstEnergyRate: "Renovation Saving Rate",
    firstEnergyV2: "Renovation Saving (Rate)",
    secondEnergyV2: "Smart Saving (Rate)",
    energyMode: "Energy Consumption (Statistics) Mode",
    designEnergyConsumption: "Expected Energy Consumption",
    rulesDes: 'Rules Explanation',
    rulesOpenDes: "Working hours: Total Expected Energy = Lights rated power * light numbers* working hours. Non working hours: Total Expected Energy = Lights rated power * lights ON numbers * non-working hours.",
    rulesCloseDes: 'Total Expected energy of working days = Lights rated power * Lights ON numbers * Lights ON hours',
    rulesOpenDes1: 'Total Expected Energy = Working hours Expected Energy + Non-working hours Expected Energy',
    rulesOpenDes2: 'Working hours Expected Energy = Lights rated power * light numbers * working hours.',
    rulesOpenDes3: 'Non-working hours Expected Energy = Lights rated power * lights ON numbers * Non-working hours.',
    open: 'ON/Enable',
    closed: 'OFF/Disable',
    infoFrom: "The information is sourced from 'Project' - 'Country Info' - 'Country of Affiliation'",
    infoFrom1: 'The information is sourced from：',
    infoFrom2: 'Project - Country Info - Country',
    city: 'City',
    building: 'building',
    floor: 'Floor',
    room: 'Room',
    selectAreaType: "Selected ${{n}} groups",
    tip1: 'Data Explanation',
    tip2: 'Expected Energy Consumption =Actual Energy Consumption + Saved Energy Consumption；',
    tip3: 'Saved Energy Consumption = Renovation Energy Saving+ Smart Energy Saving；',
    tip4: 'Average Energy Saving Rate = Saved Energy Consumption / Expected Energy Consumption;',
    tip5: 'Smart Saving Rate =(Renovation Exptected Energy Consumption-Actual Energy Consumption) / Renovation exptected energy',
    tip6: 'Renovation Saving Rate =(Before Renovation Energy-Renovation Expected Energy) / Before Renovation Energy',
    noPermissionContactOwner: 'You currently lack permission to modify settings. Please contact the project creator to enable this function.'
  },
  recycle: {
    dataRecovery: 'Data Recovery',
    sceneAutomationDeleteTips: 'The remaining days before scenes and automations are permanently deleted will be displayed',
    restore: 'Restore',
    deviceCannotBeEmpty: 'Device cannot be empty, unable to restore this data',
    relatedDeviceDeleted: 'Related device has been deleted, unable to restore',
    triggerActionCannotBeEmpty: 'Trigger action cannot be empty, unable to restore this data',
    executionActionCannotBeEmpty: 'Execution action cannot be empty, unable to restore this data',
    day: 'Day(s)'
  },
  notices: {
    noticeTimes: 'Set Notification Frequency',
    timeInterval: 'Time interval',
    timeCount1: '15 minutes',
    timeCount2: '30 minutes',
    timeCount3: '1 hour',
    timeCount4: '12 hours',
    timeCount5: '24 hours',
    timeInterval_title1: 'Immediate Notification',
    timeInterval_title2: 'Notification by hourly by Device',
    timeInterval_title3: 'Notification by time',
    timeInterval_title4: 'Stop notifications',
    timeInterval_description1: 'Trigger notification when the device changes status.',
    timeInterval_description2: 'No matter how many times the device meets the trigger conditions, each device will be notified only once within 1 hour.',
    timeInterval_description3: 'Within the set interval, each device is notified only once, regardless of how many times the device meets the trigger conditions.',
    timeInterval_description4: 'No notification after the trigger condition is met',
    subscription_name: 'Subscription Name',
    subscription_type: 'Subscription Type',
    sensor_alarm: 'Sensor Alerts',
    addSpecifiedDevice: 'Add Specified Device',
    triggerConditions: 'Trigger conditions',
    meetAllSensors: 'Satisfy all sensors',
    satisfyAnySensor: 'Any sensor',
    alarmConfiguration: 'Alarm Configuration',
    notificationObject: 'Notification Objects',
    auth: 'Permission',
    notifSelf: 'Notify me by default',
    specifyUser: 'Designated User',
    pushUser: 'Push users',
    method: 'Notification method',
    subscriptionCenter: 'Subscription Centre',
    allSubscriptions: 'All Subscriptions',
    addSubscription: 'Add Subscription',
    all: 'All',
    noticeList: 'If you want to edit or cancel this notification, Please contact any of the following accounts.',
    know: 'Got it',
    checkDelete: 'Confirm deletion? This action is irrevocable!',
    deleteSuccess: 'Delete Successful',
    watchAll: 'View all messages',
    messageCenter: 'Message Centre',
    sendDate: 'Date sent',
    ownProject: 'Project',
    messageDetails: 'Message details',
    processedMan: 'Processor',
    isHandle: 'Processed or not',
    processed: 'Processed',
    notProcessed: 'Unprocessed',
    clickHandler: 'Click to process',
    checkHandler: 'Do you confirm that the message has been processed? This action cannot be withdrawn!',
    readAll: 'Mark as all read',
    processedSuccess: 'Processed successfully',
    selectDate: 'Select date',
    markAsProcessed: 'Mark as processed',
    readed: 'Read',
    unRead: 'Unread',
    project: 'Item',
    systemNotifications: 'System Notification',
    emailNotifications: 'Email Notification',
    messageNotifications: 'SMS Notification',
    appPush: 'App Notification',
    sensor: 'Sensor',
    processingTime: 'Processing time',
    envAlarm: 'Environmental category',
    areaAlarm: 'Regional category',
    envAlarmTip: '(Use the data reported by the sensor as a trigger condition to push alarms or notifications when the environment changes to meet the set conditions.)',
    areaAlarmTip: '(Push system data related to the designated area at regular intervals)',
    noticeByDay: 'Daily Push',
    noticeByWeek: 'Weekly Push',
    noticeByMonth: 'Monthly Push',
    pushTime: 'Push time',
    noticeByDayDescription: "(Once a day, push yesterday's data.)",
    noticeByWeekDescription: "(Daily push time to push last week's data)",
    noticeByMonthDescription: "(Daily push time to push last month's data)",
    eachMonday: 'every Monday',
    eachTuesday: 'every Tuesday',
    eachWednesday: 'every Wednesday',
    eachThursday: 'every Thursday',
    eachFriday: 'every Friday',
    eachSaturday: 'every Saturday',
    eachSunday: 'every Sunday',
    pushContent: 'Push content',
    temperature: 'temperature and humidity',
    faultProportion: 'percentage of faults',
    thirdPartyAccount: 'Third-party personal accounts',
    thirdPartyGroupAccount: 'Third Party Group Accounts',
    batchImport: 'Batch import',
    downloadImportTemplate: 'Download Import Template',
    oppleUser: 'OPPLE Subscribers',
    thirdParty: 'Third-party user',
    personalAccount: 'personal account',
    groupAccount: 'group account',
    oppleUserAccount: 'OPPLE Subscribers',
    thirdPartyPersonalAccount: 'Third-party individual users',
    thirdPartyGroup: 'Third-party group',
    deviceTotal: 'Total number of devices, online, offline data',
    energyStatistics: 'Actual energy consumption, energy savings, energy saving rate',
    areaTemperature: 'Regional temperature and humidity data',
    areaFaultProportion: 'Data on the percentage of faulty equipment in the region (same as APP - Faulty Equipment Details)',
    addAccount: 'Add Account',
    batchDelete: 'Batch deletion',
    importTemplate: 'Import Templates',
    areaCodeError: 'Duplicate GpNo',
    messagePush: 'Message Push',
    pushMethod: 'Push Method',
    pushApp: 'Push to mobile app',
    timeStamp: 'Timestamps',
    Day: 'Day'
  },
  icp: {
    company: 'Suzhou Opple Lighting Co.',
    icpNo: 'Su ICP 13004515',
    networkSecurity: 'Su public network security reserve No.32050902100527'
  },
  networkCheck: {
    networkCheck: 'Evaluate the network communications for this project',
    selectArea: 'Please select the area',
    cloudServer: 'Cloud servers',
    normalSubDevice: 'Normal',
    abnormalSubDevice: 'Packet Loss Device',
    offlineSubDevices: 'Offline',
    weakSignal: 'Communication signal is weak',
    linkNotWorking: 'Network communication failed',
    signalDifferenceEquipment: 'Devices with weak communication signal',
    offlineDevice: 'Offline devices',
    unableGateway: 'Unable to complete the linked gateway',
    reset: 'Reset to factory mode',
    others: 'Directly communicating devices',
    affectedIfttt: 'Affected automation',
    affectedIftttTip: 'Smart Connect Boxs under the automation system are located on different local area networks or network segments, resulting in network disconnection and abnormal communication.',
    serverCloud: 'Cloud servers',
    signalStrength: 'Signal strength',
    communicationRate: 'Communication success rate',
    noGateway: 'The project without Smart Connect Box  cannot continue to evaluate its network status.',
    notCompatible: 'Verbindung zum Cloud-Server fehlgeschlagen',
    test: 'Evaluate',
    communicationTimes: 'The communication status',
    concatIt: 'Please contact IT',
    deviceList: 'Devices List',
    completed: 'All completed',
    DetectionTool: 'Tools',
    correspondingGateway: 'Corresponding Smart Connect Box',
    networkSegment: 'Network Segment',
    waitingToStart: 'Waiting to start',
    onlyWin: 'Only supported on Windows systems.',
    toolsTip: 'Use the following tool to check whether the current local area network allows access to the domain names and ports required by OPPLE Cloud.',
    smallTool: 'Auxiliary Tool',
    localAreaNetwork: 'You may contact IT to adjust the network and ensure the corresponding Smart Connect Box is on the same local area network.',
    status1: 'Waiting',
    status2: 'Detecting',
    status3: 'Detection Completed',
    abnormalCause: 'Abnormal Cause',
    solution: 'Solution',
    normalCommunication: 'Adjust network configuration to ensure that gateways under the automation system are in the same LAN environment to restore normal communication.',
    judgmentCriteria: 'Judgment Criteria',
    poorCommunication: 'Poor signal of the current device, communication success rate lower than $$%',
    indicatorDiagram: 'Indicator Diagram',
    threeIndicators: 'The following three indicators: (1) System Indicator, (2) LAN Indicator, (3) Cloud Connection Indicator',
    troubleshootingSteps: 'troubleshootingSteps',
    step1_v1: '1. If all three indicators are off, it may be abnormal power supply or system failure. Check the power supply or replace the hardware.',
    step2_v1: '2. If LAN Indicator (2) is on and Cloud Connection Indicator (3) is blinking, external network access is normal but connection to OPPLE Cloud is abnormal. Check local domain and port restrictions to ensure domains and ports used by Opple are not restricted.',
    domainLabel: 'Domain Name:',
    portLabel: 'Port:',
    step3_v1: '3. If LAN Indicator (2) is on and Cloud Connection Indicator (3) is off, the Smart Connect Box cannot access the external network. Check local network restrictions.',
    step4_v1: '4. If LAN Indicator (2) is off, the Smart Connect Box fails to obtain an IP. Check for abnormal network cable connection, DHCP restrictions on the Smart Connect Box, and correct Smart Connect Box IP configuration when using static IP.',
    fourIndicators: 'The following four indicators: (1) Status indicator light (2) LAN indicator light (3) Internet indicator light (4)Wi-Fi indicator light',
    step1_v2: '1. If Status indicator light(1) is off, it may be abnormal power supply. Please check the power supply.',
    step2_v2: '2. If LAN indicator light (2), Internet indicator light (3) and Wi-Fi indicator light (4) are all off, it may be system failure. Please replace the hardware.',
    step3_v2: '3. If Internet indicator light (3) is on and Wi-Fi indicator light (4) is flashing, external network access is normal but connection to OPPLE Cloud is abnormal. Check local domain and port restrictions to ensure domains and ports used by OPPLE are not restricted.',
    officialDomain: 'Official Domestic Cloud Domain Name (Domain name determined by project; Europe: iotctrl1):',
    step4_v2: '4. If Internet indicator light (3) is on and Wi-Fi indicator light (4) is off, the Smart Connect Box cannot access the external network. Check local network restrictions.',
    step5_v2: '5. If Internet indicator light (3) is off, the Smart Connect Box fails to obtain an IP. Check for abnormal network cable connection, DHCP restrictions on the Smart Connect Box, and correct Smart Connect Box IP configuration when using static IP.',
    fourIndicators_v3: 'Four indicators below: System indicator(1), LAN indicator(2), Cloud connection indicator(3), WiFi indicator(4)',
    step1_v3: '1. If all four indicators are off, it may be due to abnormal power supply or system failure, check the power supply or replace the hardware',
    wifiStatusDesc: 'Wi-Fi indicator light (4) Description',
    wifiOff: 'Off: Wi-Fi not in use.',
    wifiRedFlash: 'Red (flashing): Wi-Fi SSID or password not configured.',
    wifiRedOn: 'Red (steady on): Attempting to connect to Wi-Fi (AP).',
    wifiGreenFlash: 'Green (flashing): Connected to Wi-Fi but no IP assigned.',
    wifiGreenOn: 'Green (steady on): Connected to Wi-Fi and IP obtained.',
    issueType: 'Problem Type',
    correspondingGateway2: 'Corresponding Smart Connect Box',
    crossNetwork: 'Cross-network Segment',
    crossGateway: 'Cross-Smart Connect Box'
  },
  controlArea: {
    bindRoomError1: 'The knob and some lights ({names}) are not on the same gateway. Dimming is temporarily unavailable. Please move them to the same gateway.',
    bindRoomError2: 'The knob and all lights in this room are not on the same gateway and cannot be controlled. Please connect them to the same gateway.',
    bindRoomError3: 'There are no controllable lights in this room. Please move the knob to a room with lights or select another room.',
    reSelect: 'Reselect',
    knew: 'Got it',
  },
  ...Locale,
}
export default en
